webpackJsonp([117],{

/***/ "+1nI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var inStockList = function inStockList(r) {
  return __webpack_require__.e/* require.ensure */(74).then((function () {
    return r(__webpack_require__("SjNE"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictInStock = [{
  path: '/antichannelconflict/instock',
  name: 'antiChannelConflict-inStock',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/instock/list',
  children: [{
    path: 'list',
    component: inStockList,
    name: 'antiChannelConflict-inStock-list',
    meta: {
      displayName: '入库单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictInStock);

/***/ }),

/***/ "+4Ni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var schedulingList = function schedulingList(r) {
  return __webpack_require__.e/* require.ensure */(67).then((function () {
    return r(__webpack_require__("FUyZ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemScheduling = [{
  path: '/system/scheduling',
  name: 'system-scheduling',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/scheduling/list',
  hidden: true,
  children: [{
    path: 'list',
    component: schedulingList,
    name: 'system-scheduling-list',
    meta: {
      displayName: '计划任务',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemScheduling);

/***/ }),

/***/ "+SxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var marketingActionList = function marketingActionList(r) {
  return __webpack_require__.e/* require.ensure */(80).then((function () {
    return r(__webpack_require__("k+UX"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingActionConfig = [{
  path: '/marketing/marketingAction',
  name: 'marketing-marketingAction',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/marketingAction/list',
  hidden: true,
  children: [{
    path: 'list',
    component: marketingActionList,
    name: 'system-marketingAction-list',
    meta: {
      displayName: '签呈管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingActionConfig);

/***/ }),

/***/ "+UP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var activityUserGrantyList = function activityUserGrantyList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("nWK2"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var apendedUserGrantyList = function apendedUserGrantyList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("PvvV"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingActivityUserGranty = [{
  path: '/marketing/activityUserGrant',
  name: 'marketing-activityUserGrant',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/activityUserGrant/list',
  hidden: true,
  children: [{
    path: 'list',
    component: activityUserGrantyList,
    name: 'marketing-activityUserGrant-list',
    meta: {
      displayName: '待审核用户',
      requireAuth: true
    }
  }]
}, {
  path: '/marketing/activityUserGrant',
  name: 'marketing-activityUserGrant',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/activityUserGrant/apendedUser',
  hidden: true,
  children: [{
    path: 'apendedUser',
    component: apendedUserGrantyList,
    name: 'marketing-activityUserGrant-apendedUser',
    meta: {
      displayName: '已审核用户',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingActivityUserGranty);

/***/ }),

/***/ "+jFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var replenishProductPropertyValueList = function replenishProductPropertyValueList(r) {
  return __webpack_require__.e/* require.ensure */(35).then((function () {
    return r(__webpack_require__("QhIy"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishProductPropertyValue = [{
  path: '/replenishment/replenishproductpropertyvalue',
  name: 'replenishment-replenishProductPropertyValue',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/replenishProductPropertyValue/list',
  hidden: true,
  children: [{
    path: 'list',
    component: replenishProductPropertyValueList,
    name: 'replenishment-replenishProductPropertyValue-list',
    meta: {
      displayName: '补货产品属性分类管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishProductPropertyValue);

/***/ }),

/***/ "/7tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var dealerBlackList = function dealerBlackList(r) {
  return __webpack_require__.e/* require.ensure */(65).then((function () {
    return r(__webpack_require__("eSKk"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var dealerBlack = [{
  path: '/wechatExcellent/dealerBlack',
  name: 'wechatExcellent-dealerBlack',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/dealerBlack/list',
  hidden: true,
  children: [{
    path: 'list',
    component: dealerBlackList,
    name: 'wechatExcellent-dealerBlack-list',
    meta: {
      displayName: '黑名单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (dealerBlack);

/***/ }),

/***/ "/Vqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var newSmsList = function newSmsList(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__("R3ds"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var newSmslogList = function newSmslogList(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__("Jsjg"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemNewSms = [{
  path: '/system/newSms',
  name: 'system-newSms',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/newSms/list',
  hidden: true,
  children: [{
    path: 'list',
    component: newSmsList,
    name: 'system-newSms-list',
    meta: {
      displayName: '短信配置',
      requireAuth: true
    }
  }, {
    path: 'logList',
    component: newSmslogList,
    name: 'system-newSms-logList',
    meta: {
      displayName: '短信日志',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemNewSms);

/***/ }),

/***/ "/l5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var dataList = function dataList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__("s4EP"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var testList = [{
  path: '/antiChannelconflict/checkUserAccount',
  name: 'antiChannelconflict-checkUserAccount',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antiChannelconflict/checkUserAccount/list',
  children: [{
    path: 'List',
    name: 'antiChannelconflict-checkUserAccount-List',
    component: dataList,
    meta: {
      displayName: '稽查人员管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (testList);

/***/ }),

/***/ "/lsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var replenishProductBrandList = function replenishProductBrandList(r) {
  return __webpack_require__.e/* require.ensure */(46).then((function () {
    return r(__webpack_require__("9H6d"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishProductBrand = [{
  path: '/replenishment/replenishproductbrand',
  name: 'replenishment-replenishProductBrand',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/replenishProductBrand/list',
  hidden: true,
  children: [{
    path: 'list',
    component: replenishProductBrandList,
    name: 'replenishment-replenishProductBrand-list',
    meta: {
      displayName: '补货产品品牌管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishProductBrand);

/***/ }),

/***/ "0bkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log(1);
    }
  }
});

/***/ }),

/***/ "1uch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var posList = function posList(r) {
  return __webpack_require__.e/* require.ensure */(44).then((function () {
    return r(__webpack_require__("G25c"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var salesPOS = [{
  path: '/sales/pos',
  name: 'sales-pos',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/sales/pos/list',
  hidden: true,
  children: [{
    path: 'list',
    component: posList,
    name: 'sales-pos-list',
    meta: {
      displayName: '销售站点管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (salesPOS);

/***/ }),

/***/ "2Bnn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var marketingImagesList = function marketingImagesList(r) {
  return __webpack_require__.e/* require.ensure */(71).then((function () {
    return r(__webpack_require__("S4O2"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingImagesConfig = [{
  path: '/marketing/marketingImages',
  name: 'marketing-marketingImages',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/marketingImages/list',
  hidden: true,
  children: [{
    path: 'list',
    component: marketingImagesList,
    name: 'marketing-marketingImages-list',
    meta: {
      displayName: '金冠拍照明细',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingImagesConfig);

/***/ }),

/***/ "2cr8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var dealerUpdatePendingList = function dealerUpdatePendingList(r) {
  return __webpack_require__.e/* require.ensure */(75).then((function () {
    return r(__webpack_require__("rszd"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictdealerUpdate = [{
  path: '/antichannelconflict/dealerupdate',
  name: 'antiChannelConflict-dealerUpdate',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/dealerupdate/pendingList',
  children: [{
    path: 'pendingList',
    component: dealerUpdatePendingList,
    name: 'antiChannelConflict-dealerUpdate-pendingList',
    meta: {
      displayName: '经销商升级管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictdealerUpdate);

/***/ }),

/***/ "33r8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var awardList = function awardList(r) {
  return __webpack_require__.e/* require.ensure */(101).then((function () {
    return r(__webpack_require__("BFbu"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var exhibitionHallAward = [{
  path: '/exhibitionHall/award',
  name: 'exhibitionHall-award',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/exhibitionHall/award/list',
  hidden: true,
  children: [{
    path: 'list',
    component: awardList,
    name: 'exhibitionHall-award-list',
    meta: {
      displayName: '奖品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (exhibitionHallAward);

/***/ }),

/***/ "3RIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var newsList = function newsList(r) {
  return __webpack_require__.e/* require.ensure */(33).then((function () {
    return r(__webpack_require__("NRT2"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var wechatExcellentNews = [{
  path: '/wechatExcellent/news',
  name: 'wechatExcellent-news',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/news/list',
  hidden: true,
  children: [{
    path: 'list',
    component: newsList,
    name: 'wechatExcellent-news-list',
    meta: {
      displayName: '商城内容管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (wechatExcellentNews);

/***/ }),

/***/ "43a5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Lha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("atCi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c99b25e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("ifeo");
function injectStyle (ssrContext) {
  __webpack_require__("rmPg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c99b25e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c99b25e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4z9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appMain',
  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();
    }
  }
});

/***/ }),

/***/ "5reV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var integralList = function integralList(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__("JNwg"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var memberIntegralList = function memberIntegralList(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__("zzRM"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ywtIntegral = [{
  path: '/ywt/integral',
  name: 'ywt-integral',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/ywt/integral/list',
  children: [{
    path: 'list',
    name: 'ywt-integral-list',
    component: integralList,
    meta: {
      displayName: '积分管理',
      requireAuth: true
    }
  }, {
    path: 'memberintegrallist',
    name: 'ywt-memberintegral-list',
    component: memberIntegralList,
    meta: {
      displayName: '返款明细',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (ywtIntegral);

/***/ }),

/***/ "6Yu4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6uCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tabs-view',
  data: function data() {
    return {};
  },

  methods: {
    isActive: function isActive(path) {
      // console.log(this.$route.matched)
      return path === this.$route.path;
    },
    closeViewTabs: function closeViewTabs(view, $event) {
      var _this = this;

      this.$store.dispatch('app/delVisitedViews', view).then(function (views) {
        if (_this.isActive(view.path)) {
          var latestView = views.slice(-1)[0];
          if (latestView) {
            _this.$router.push(latestView.path);
          } else {
            _this.$router.push('/');
          }
        }
      });
      $event.preventDefault();
    },
    generateRoute: function generateRoute() {
      if (this.$route.matched[this.$route.matched.length - 1].meta.displayName) {
        return this.$route.matched[this.$route.matched.length - 1];
      }
      this.$route.matched[0].path = '/';
      return this.$route.matched[0];
    },
    addViewTabs: function addViewTabs() {
      this.$store.dispatch('app/addVisitedViews', this.generateRoute());
    }
  },
  computed: {
    visitedViews: function visitedViews() {
      return this.$store.state.app.visitedViews.slice(-6);
    }
  },
  watch: {
    $route: function $route() {
      this.addViewTabs();
    }
  }
});

/***/ }),

/***/ "7CXz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var codeList = function codeList(r) {
  return __webpack_require__.e/* require.ensure */(72).then((function () {
    return r(__webpack_require__("Ec5Z"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var issuerCode = [{
  path: '/issuer/code',
  name: 'issuer-code',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/issuer/code/list',
  children: [{
    path: 'list',
    name: 'issuer-code-list',
    component: codeList,
    meta: {
      displayName: '发行码',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (issuerCode);

/***/ }),

/***/ "7PgO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var templateMessageList = function templateMessageList(r) {
  return __webpack_require__.e/* require.ensure */(66).then((function () {
    return r(__webpack_require__("NWAW"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemTemplateMessage = [{
  path: '/system/templatemessage',
  name: 'system-templateMessage',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/templatemessage/list',
  children: [{
    path: 'list',
    component: templateMessageList,
    name: 'system-templateMessage-list',
    meta: {
      displayName: '模板消息',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemTemplateMessage);

/***/ }),

/***/ "8/Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var chartList = function chartList(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__("ajfo"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingChart = [{
  path: '/marketing/chart',
  name: 'marketing-chart',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/chart/list',
  hidden: true,
  children: [{
    path: 'list',
    component: chartList,
    name: 'marketing-chart-list',
    meta: {
      displayName: '营销报表管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingChart);

/***/ }),

/***/ "8bCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var codeList = function codeList(r) {
  return __webpack_require__.e/* require.ensure */(108).then((function () {
    return r(__webpack_require__("vrV8"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiFakeCode = [{
  path: '/antifake/code',
  name: 'antiFake-code',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antifake/code/list',
  children: [{
    path: 'list',
    name: 'antiFake-code-list',
    component: codeList,
    meta: {
      displayName: '防伪码列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiFakeCode);

/***/ }),

/***/ "8vIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var wechatExcellentOrderList = function wechatExcellentOrderList(r) {
  return __webpack_require__.e/* require.ensure */(39).then((function () {
    return r(__webpack_require__("89em"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var wechatExcellentOrderTabsList = function wechatExcellentOrderTabsList(r) {
  return __webpack_require__.e/* require.ensure */(62).then((function () {
    return r(__webpack_require__("dv/I"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var wechatExcellentOrder = [{
  path: '/wechatExcellent/order',
  name: 'wechatExcellent-order',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/order/tabslist',
  hidden: true,
  children: [{
    path: 'list',
    component: wechatExcellentOrderList,
    name: 'wechatExcellent-order-list',
    meta: {
      displayName: '经销商订单管理',
      requireAuth: true
    }
  }, {
    path: 'tabslist',
    component: wechatExcellentOrderTabsList,
    name: 'wechatExcellent-order-list',
    meta: {
      displayName: '订单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (wechatExcellentOrder);

/***/ }),

/***/ "9EKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var activityList = function activityList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("JXCq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingActivity = [{
  path: '/marketing/activity',
  name: 'marketing-activity',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/activity/list',
  hidden: true,
  children: [{
    path: 'list',
    component: activityList,
    name: 'marketing-activity-list',
    meta: {
      displayName: '活动管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingActivity);

/***/ }),

/***/ "9op+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var stockList = function stockList(r) {
  return __webpack_require__.e/* require.ensure */(109).then((function () {
    return r(__webpack_require__("nCV/"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictStock = [{
  path: '/antichannelconflict/stock',
  name: 'antiChannelConflict-stock',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/stock/list',
  children: [{
    path: 'list',
    component: stockList,
    name: 'antiChannelConflict-stock-list',
    meta: {
      displayName: '库存查询',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictStock);

/***/ }),

/***/ "9x8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productExtendList = function productExtendList(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__("ZgLG"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productExtend = [{
  path: '/wechatExcellent/productExtend',
  name: 'wechatExcellent-productExtend',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/productExtend/list',
  hidden: true,
  children: [{
    path: 'list',
    component: productExtendList,
    name: 'wechatExcellent-productExtend-list',
    meta: {
      displayName: '商品扩展信息',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productExtend);

/***/ }),

/***/ "A2m0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var consumerFeedbackList = function consumerFeedbackList(r) {
  return __webpack_require__.e/* require.ensure */(86).then((function () {
    return r(__webpack_require__("mGUg"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var wechatExcellentConsumerFeedback = [{
  path: '/wechatExcellent/consumerFeedback',
  name: 'wechatExcellent-consumerFeedback',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/consumerFeedback/list',
  hidden: true,
  children: [{
    path: 'list',
    component: consumerFeedbackList,
    name: 'wechatExcellent-consumerFeedback-list',
    meta: {
      displayName: '消费者反馈',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (wechatExcellentConsumerFeedback);

/***/ }),

/***/ "ADiv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var autoTableList = function autoTableList(r) {
  return __webpack_require__.e/* require.ensure */(30).then((function () {
    return r(__webpack_require__("fqfK"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var autoTable = [{
  path: '/autoTable/table',
  name: 'autoTable-table',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/autoTable/table/list',
  hidden: true,
  children: [{
    path: 'list',
    component: autoTableList,
    name: 'autoTable-table-list',
    meta: {
      displayName: '动态表管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (autoTable);

/***/ }),

/***/ "ASjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var antiChannelConflictCodeList = function antiChannelConflictCodeList(r) {
  return __webpack_require__.e/* require.ensure */(112).then((function () {
    return r(__webpack_require__("wQ3h"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictAntiChannelConflictCode = [{
  path: '/antichannelconflict/antichannelconflictcode',
  name: 'antiChannelConflict-antiChannelConflictCode',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/antichannelconflictcode/list',
  children: [{
    path: 'list',
    component: antiChannelConflictCodeList,
    name: 'antiChannelConflict-antiChannelConflictCode-list',
    meta: {
      displayName: '防窜码列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictAntiChannelConflictCode);

/***/ }),

/***/ "AlMv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var posList = function posList(r) {
  return __webpack_require__.e/* require.ensure */(45).then((function () {
    return r(__webpack_require__("TCUj"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var salesAreaManager = [{
  path: '/sales/areaManager',
  name: 'sales-areaManager',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/sales/areaManager/list',
  hidden: true,
  children: [{
    path: 'list',
    component: posList,
    name: 'sales-areaManager-list',
    meta: {
      displayName: '区域负责人管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (salesAreaManager);

/***/ }),

/***/ "As03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var mallProductPropertyCategoryList = function mallProductPropertyCategoryList(r) {
  return __webpack_require__.e/* require.ensure */(19).then((function () {
    return r(__webpack_require__("k19j"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallProductPropertyCategory = [{
  path: '/mall/mallProductpropertycategory',
  name: 'mall-mallProductPropertyCategory',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/mallProductpropertycategory/list',
  hidden: true,
  children: [{
    path: 'list',
    component: mallProductPropertyCategoryList,
    name: 'mall-mallProductPropertyCategory-list',
    meta: {
      displayName: '产品属性分类',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallProductPropertyCategory);

/***/ }),

/***/ "B/Vv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var joinInApplyList = function joinInApplyList(r) {
  return __webpack_require__.e/* require.ensure */(82).then((function () {
    return r(__webpack_require__("zxof"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var joinInApply = [{
  path: '/wechatExcellent/joinInApply',
  name: 'wechatExcellent-joinInApply',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/joinInApply/list',
  hidden: true,
  children: [{
    path: 'list',
    component: joinInApplyList,
    name: 'wechatExcellent-joinInApply-list',
    meta: {
      displayName: '加盟申请管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (joinInApply);

/***/ }),

/***/ "BWOF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bj3L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var deliveryTemplateList = function deliveryTemplateList(r) {
  return __webpack_require__.e/* require.ensure */(53).then((function () {
    return r(__webpack_require__("uar3"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallDeliveryTemplate = [{
  path: '/mall/deliverytemplate',
  name: 'mall-deliveryTemplate',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/deliverytemplate/list',
  hidden: true,
  children: [{
    path: 'list',
    component: deliveryTemplateList,
    name: 'mall-deliveryTemplate-list',
    meta: {
      displayName: '运费模板',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallDeliveryTemplate);

/***/ }),

/***/ "BtP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var mallProductPropertyList = function mallProductPropertyList(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__("2uF5"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallProductProperty = [{
  path: '/mall/mallProductProperty',
  name: 'mall-mallProductProperty',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/mallProductProperty/list',
  hidden: true,
  children: [{
    path: 'list',
    component: mallProductPropertyList,
    name: 'mall-mallProductProperty-list',
    meta: {
      displayName: '产品属性类型',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallProductProperty);

/***/ }),

/***/ "CuH2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var smsList = function smsList(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__("YdRk"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var logList = function logList(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__("szxv"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemSms = [{
  path: '/system/sms',
  name: 'system-sms',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/sms/configlist',
  hidden: true,
  children: [{
    path: 'configlist',
    component: smsList,
    name: 'system-sms-configList',
    meta: {
      displayName: '短信配置',
      requireAuth: true
    }
  }, {
    path: 'loglist',
    component: logList,
    name: 'system-sms-logList',
    meta: {
      displayName: '短信日志',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemSms);

/***/ }),

/***/ "D8b9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var awardList = function awardList(r) {
  return __webpack_require__.e/* require.ensure */(49).then((function () {
    return r(__webpack_require__("MWOh"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingAward = [{
  path: '/marketing/award',
  name: 'marketing-award',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/award/list',
  hidden: true,
  children: [{
    path: 'list',
    component: awardList,
    name: 'marketing-award-list',
    meta: {
      displayName: '奖品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingAward);

/***/ }),

/***/ "DJNP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var outStockList = function outStockList(r) {
  return __webpack_require__.e/* require.ensure */(27).then((function () {
    return r(__webpack_require__("sDbZ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var outSimpleStockList = function outSimpleStockList(r) {
  return __webpack_require__.e/* require.ensure */(20).then((function () {
    return r(__webpack_require__("RMMh"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictOutStock = [{
  path: '/antichannelconflict/outstock',
  name: 'antiChannelConflict-outStock',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/outstock/list',
  children: [{
    path: 'list',
    component: outStockList,
    name: 'antiChannelConflict-outStock-list',
    meta: {
      displayName: '出库单管理',
      requireAuth: true
    }
  }, {
    path: 'listsimple',
    component: outSimpleStockList,
    name: 'antiChannelConflict-outStock-listSimple',
    meta: {
      displayName: '出库单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictOutStock);

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SIGN_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SIGN_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ACCESS_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ADMIN_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TOGGLE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_VISITED_VIEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEL_VISITED_VIEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_MODULE_MENUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_MENUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ACTIVE_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_SYSTEM_TITLE; });
var SIGN_IN = 'SIGN_IN';
var SIGN_OUT = 'SIGN_OUT';
var GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN';
var GET_ADMIN_INFO = 'GET_ADMIN_INFO';

var TOGGLE_LOADING = 'TOGGLE_LOADING';

var ADD_VISITED_VIEWS = 'ADD_VISITED_VIEWS';
var DEL_VISITED_VIEWS = 'DEL_VISITED_VIEWS';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var GET_MODULE_MENUS = 'GET_MODULE_MENUS';
var GET_MENUS = 'GET_MENUS';

var SET_ACTIVE_INDEX = 'SET_ACTIVE_INDEX';
var ACTIVE_MENU = 'ACTIVE_MENU';

var GET_SYSTEM_TITLE = 'GET_SYSTEM_TITLE';

/***/ }),

/***/ "Dxc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http__ = __webpack_require__("gfkZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__("gyMJ");




var _mutations;






var state = {
  access_token: null,
  adminInfo: {}
};

var actions = {
  singIn: function singIn(_ref, data) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_6__api__["_299" /* login */], data).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SIGN_IN */], res.data);
    });
  },
  getAccessToken: function getAccessToken(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* GET_ACCESS_TOKEN */]);
  },
  signOut: function signOut(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SIGN_OUT */]);
  },
  getAdminInfo: function getAdminInfo(_ref4) {
    var _this = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_6__api__["_70" /* currentAdminInfo */]).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* GET_ADMIN_INFO */], res.data);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SIGN_IN */], function (state, playload) {
  localStorage.access_token = playload.accessToken;
  state.access_token = playload.accessToken;
  __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
    path: decodeURIComponent(__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].currentRoute.query.redirect || '/')
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SIGN_OUT */], function (state) {
  state.access_token = null;
  localStorage.removeItem('access_token');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* GET_ACCESS_TOKEN */], function (state) {
  if (!state.access_token) {
    state.access_token = localStorage.access_token;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* GET_ADMIN_INFO */], function (state, playload) {
  state.adminInfo = playload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "E6zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var winnerList = function winnerList(r) {
  return __webpack_require__.e/* require.ensure */(100).then((function () {
    return r(__webpack_require__("WP2r"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var exhibitionHallWinner = [{
  path: '/exhibitionHall/winner',
  name: 'exhibitionHall-winner',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/exhibitionHall/winner/list',
  hidden: true,
  children: [{
    path: 'list',
    component: winnerList,
    name: 'exhibitionHall-winner-list',
    meta: {
      displayName: '奖品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (exhibitionHallWinner);

/***/ }),

/***/ "EyZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var mallProductCategoryList = function mallProductCategoryList(r) {
  return __webpack_require__.e/* require.ensure */(37).then((function () {
    return r(__webpack_require__("suX9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallProductCategory = [{
  path: '/mall/mallproductcategory',
  name: 'mall-mallProductCategory',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/mallProductcategory/list',
  hidden: true,
  children: [{
    path: 'list',
    component: mallProductCategoryList,
    name: 'mall-mallProductCategory-list',
    meta: {
      displayName: '产品分类',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallProductCategory);

/***/ }),

/***/ "G0TU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var freeAwardInformationList = function freeAwardInformationList(r) {
  return __webpack_require__.e/* require.ensure */(99).then((function () {
    return r(__webpack_require__("ub1M"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var freeAwardInformationActivity = [{
  path: '/marketing/freeAwardInformation',
  name: 'marketing-freeAwardInformation',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/freeAwardInformation/list',
  hidden: true,
  children: [{
    path: 'list',
    component: freeAwardInformationList,
    name: 'marketing-freeAwardInformation-list',
    meta: {
      displayName: '免费活动管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (freeAwardInformationActivity);

/***/ }),

/***/ "Hc6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var officialAccountEdit = function officialAccountEdit(r) {
  return __webpack_require__.e/* require.ensure */(90).then((function () {
    return r(__webpack_require__("pjqi"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemOfficialAccount = [{
  path: '/system/officialaccount',
  name: 'system-officialAccount',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/officialaccount/edit',
  children: [{
    path: 'edit',
    component: officialAccountEdit,
    name: 'system-officialAccount-edit',
    meta: {
      displayName: '公众号配置',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemOfficialAccount);

/***/ }),

/***/ "I3yB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var packingRuleList = function packingRuleList(r) {
  return __webpack_require__.e/* require.ensure */(60).then((function () {
    return r(__webpack_require__("+5Mv"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictPackingRule = [{
  path: '/antichannelconflict/packingRule',
  name: 'antiChannelConflict-packingRule',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/packingRule/list',
  children: [{
    path: 'list',
    component: packingRuleList,
    name: 'antiChannelConflict-packingRule-list',
    meta: {
      displayName: '配码管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictPackingRule);

/***/ }),

/***/ "IKF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var menuList = function menuList(r) {
  return __webpack_require__.e/* require.ensure */(18).then((function () {
    return r(__webpack_require__("izjL"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var officialAccountsMenu = [{
  path: '/officialaccounts/menu',
  name: 'officialAccounts-menu',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/officialaccounts/menu/list',
  hidden: true,
  children: [{
    path: 'list',
    component: menuList,
    name: 'officialAccounts-menu-list',
    meta: {
      displayName: '商户列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (officialAccountsMenu);

/***/ }),

/***/ "IXym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var resourceList = function resourceList(r) {
  return __webpack_require__.e/* require.ensure */(41).then((function () {
    return r(__webpack_require__("EIiT"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var updateList = function updateList(r) {
  return __webpack_require__.e/* require.ensure */(42).then((function () {
    return r(__webpack_require__("nCjy"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var updaterResource = [{
  path: '/updater/resource',
  name: 'updater-resource',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/updater/resource/list',
  hidden: true,
  children: [{
    path: 'list',
    component: resourceList,
    name: 'updater-resource-list',
    meta: {
      displayName: '资源管理',
      requireAuth: true
    }
  }, {
    path: 'update/list',
    component: updateList,
    name: 'updater-resource-update-list',
    meta: {
      displayName: '资源升级管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (updaterResource);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_account__ = __webpack_require__("Dxc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__("WSTi");







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var state = {
  showLoading: false
};

var actions = {
  toggleLoading: function toggleLoading(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* TOGGLE_LOADING */]);
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* TOGGLE_LOADING */], function (state) {
  state.showLoading = !state.showLoading;
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  actions: actions,
  mutations: mutations,
  modules: {
    account: __WEBPACK_IMPORTED_MODULE_4__modules_account__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */]
  }
}));

/***/ }),

/***/ "Iegp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var advertList = function advertList(r) {
  return __webpack_require__.e/* require.ensure */(26).then((function () {
    return r(__webpack_require__("TRY5"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var basicAdvert = [{
  path: '/basic/advert',
  name: 'basic-advert',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/basic/advert/list',
  hidden: true,
  children: [{
    path: 'list',
    component: advertList,
    name: 'basic-advert-list',
    meta: {
      displayName: '广告管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (basicAdvert);

/***/ }),

/***/ "IyUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var activityList = function activityList(r) {
  return __webpack_require__.e/* require.ensure */(102).then((function () {
    return r(__webpack_require__("Wk+j"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var exhibitionHallActivity = [{
  path: '/exhibitionHall/activity',
  name: 'exhibitionHall-activity',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/exhibitionHall/activity/list',
  hidden: true,
  children: [{
    path: 'list',
    component: activityList,
    name: 'exhibitionHall-activity-list',
    meta: {
      displayName: '活动管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (exhibitionHallActivity);

/***/ }),

/***/ "JNZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var serviceOrderList = function serviceOrderList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("4Sko"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ywtServiceOrder = [{
  path: '/ywt/serviceOrder',
  name: 'ywt-serviceOrder',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/ywt/serviceOrder/list',
  children: [{
    path: 'list',
    name: 'ywt-serviceOrder-list',
    component: serviceOrderList,
    meta: {
      displayName: '维修管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (ywtServiceOrder);

/***/ }),

/***/ "Joow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productPropertyCategoryList = function productPropertyCategoryList(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__("Vo+6"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productsproductPropertyCategory = [{
  path: '/products/productpropertycategory',
  name: 'products-productPropertyCategory',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/products/productpropertycategory/list',
  hidden: true,
  children: [{
    path: 'list',
    component: productPropertyCategoryList,
    name: 'products-productPropertyCategory-list',
    meta: {
      displayName: '产品属性类型',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productsproductPropertyCategory);

/***/ }),

/***/ "K3ui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var responseList = function responseList(r) {
  return __webpack_require__.e/* require.ensure */(57).then((function () {
    return r(__webpack_require__("CnSV"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiFakeResponse = [{
  path: '/antifake/response',
  name: 'antiFake-response',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antifake/response/list',
  children: [{
    path: 'list',
    name: 'antiFake-response-list',
    component: responseList,
    meta: {
      displayName: '防伪查询列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiFakeResponse);

/***/ }),

/***/ "KQaJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productList = function productList(r) {
  return __webpack_require__.e/* require.ensure */(38).then((function () {
    return r(__webpack_require__("XdCX"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ywtProduct = [{
  path: '/ywt/product',
  name: 'ywt-product',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/ywt/product/list',
  children: [{
    path: 'list',
    name: 'ywt-product-list',
    component: productList,
    meta: {
      displayName: '产品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (ywtProduct);

/***/ }),

/***/ "KR8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0bkq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d16b73a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("On1p");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d16b73a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LJum":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var view404 = function view404(r) {
  return __webpack_require__.e/* require.ensure */(105).then((function () {
    return r(__webpack_require__("34W9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var view500 = function view500(r) {
  return __webpack_require__.e/* require.ensure */(104).then((function () {
    return r(__webpack_require__("ExNb"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var error = [{
  path: '/404page',
  name: '404page',
  component: view404
}, {
  path: '/500page',
  name: '505page',
  component: view500
}];

/* harmony default export */ __webpack_exports__["a"] = (error);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921fbb58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("TR5y");
function injectStyle (ssrContext) {
  __webpack_require__("6Yu4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921fbb58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_baidu_map__ = __webpack_require__("dAEq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_baidu_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_baidu_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http__ = __webpack_require__("gfkZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filter__ = __webpack_require__("bbc5");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_baidu_map___default.a, {
  ak: 'W9PRrxIyAhvC8PWXkPgodxTZVE50A0Y8'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_7__http__["a" /* default */];

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "O6zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var reportList = function reportList(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__("Z2t7"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var newDealerList = function newDealerList(r) {
  return __webpack_require__.e/* require.ensure */(84).then((function () {
    return r(__webpack_require__("ek19"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var dealerOrderList = function dealerOrderList(r) {
  return __webpack_require__.e/* require.ensure */(85).then((function () {
    return r(__webpack_require__("JjNG"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var recommendList = function recommendList(r) {
  return __webpack_require__.e/* require.ensure */(114).then((function () {
    return r(__webpack_require__("L3++"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var tempBounList = function tempBounList(r) {
  return __webpack_require__.e/* require.ensure */(113).then((function () {
    return r(__webpack_require__("jYas"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var treeList = function treeList(r) {
  return __webpack_require__.e/* require.ensure */(78).then((function () {
    return r(__webpack_require__("jm1u"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var report = [{
  path: '/wechatExcellent/report',
  name: 'wechatExcellent-report',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/report/list',
  hidden: true,
  children: [{
    path: 'list',
    component: reportList,
    name: 'wechatExcellent-report-list',
    meta: {
      displayName: '业绩报表',
      requireAuth: true
    }
  }, {
    path: 'newDealer',
    component: newDealerList,
    name: 'wechatExcellent-newdealerreport-list',
    meta: {
      displayName: '新增代理报表',
      requireAuth: true
    }
  }, {
    path: 'dealerOrderList',
    component: dealerOrderList,
    name: 'wechatExcellent-dealerOrder-list',
    meta: {
      displayName: '经销商订单',
      requireAuth: true
    }
  }, {
    path: 'recommend',
    component: recommendList,
    name: 'wechatExcellent-dealerOrder-recommendList',
    meta: {
      displayName: '股东推荐奖列表',
      requireAuth: true
    }
  }, {
    path: 'tempBoun',
    component: tempBounList,
    name: 'wechatExcellent-dealerOrder-tempBoun',
    meta: {
      displayName: '股东推荐奖列表',
      requireAuth: true
    }
  }, {
    path: 'treelist',
    component: treeList,
    name: 'wechatExcellent-dealerOrder-treelist',
    meta: {
      displayName: '王者奖励',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (report);

/***/ }),

/***/ "O9a0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var roleList = function roleList(r) {
  return __webpack_require__.e/* require.ensure */(89).then((function () {
    return r(__webpack_require__("3vCV"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemRole = [{
  path: '/system/role',
  name: 'system-role',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/role/list',
  hidden: true,
  children: [{
    path: 'list',
    component: roleList,
    name: 'system-role-list',
    meta: {
      displayName: '角色管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemRole);

/***/ }),

/***/ "On1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  主页\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QEYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var posSellerList = function posSellerList(r) {
  return __webpack_require__.e/* require.ensure */(69).then((function () {
    return r(__webpack_require__("x/PJ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var pendingList = function pendingList(r) {
  return __webpack_require__.e/* require.ensure */(68).then((function () {
    return r(__webpack_require__("YGAR"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var salesPOSSeller = [{
  path: '/sales/posSeller',
  name: 'sales-posSeller',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/sales/posSeller/list',
  hidden: true,
  children: [{
    path: 'list',
    component: posSellerList,
    name: 'sales-posSeller-list',
    meta: {
      displayName: '销售会员管理',
      requireAuth: true
    }
  }, {
    path: 'pendingList',
    component: pendingList,
    name: 'sales-posSeller-pendingList',
    meta: {
      displayName: '待审核销售会员',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (salesPOSSeller);

/***/ }),

/***/ "R0cm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var activityUserList = function activityUserList(r) {
  return __webpack_require__.e/* require.ensure */(103).then((function () {
    return r(__webpack_require__("NMmH"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var exhibitionHallActivityUser = [{
  path: '/exhibitionHall/activityuser',
  name: 'exhibitionHall-activityUser',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/exhibitionHall/activityuser/list',
  hidden: true,
  children: [{
    path: 'list',
    component: activityUserList,
    name: 'exhibitionHall-activityUser-list',
    meta: {
      displayName: '参与活动的用户',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (exhibitionHallActivityUser);

/***/ }),

/***/ "ROV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productDealerList = function productDealerList(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__("TG8/"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productsProductDealer = [{
  path: '/wechatExcellent/productDealer',
  name: 'wechatExcellent-productDealer',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/productDealer/list',
  hidden: true,
  children: [{
    path: 'list',
    component: productDealerList,
    name: 'wechatExcellent-productDealer-list',
    meta: {
      displayName: '商品经销管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productsProductDealer);

/***/ }),

/***/ "Rlrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var login = function login(r) {
  return __webpack_require__.e/* require.ensure */(76).then((function () {
    return r(__webpack_require__("+zgc"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var account = [{
  path: '/login',
  name: 'login',
  component: login
}];
// 导出默认值
/* harmony default export */ __webpack_exports__["a"] = (account);

/***/ }),

/***/ "S10J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var deliveryTemplateList = function deliveryTemplateList(r) {
  return __webpack_require__.e/* require.ensure */(47).then((function () {
    return r(__webpack_require__("VqsX"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishmentDeliveryTemplate = [{
  path: '/replenishment/deliverytemplate',
  name: 'replenishment-deliveryTemplate',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/deliverytemplate/list',
  hidden: true,
  children: [{
    path: 'list',
    component: deliveryTemplateList,
    name: 'replenishment-deliveryTemplate-list',
    meta: {
      displayName: '运费模板',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishmentDeliveryTemplate);

/***/ }),

/***/ "S9/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var memberList = function memberList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("XlcS"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ywtMember = [{
  path: '/ywt/member',
  name: 'ywt-member',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/ywt/member/list',
  children: [{
    path: 'list',
    name: 'ywt-member-list',
    component: memberList,
    meta: {
      displayName: '工程师管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (ywtMember);

/***/ }),

/***/ "Sa2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var queryList = function queryList(r) {
  return __webpack_require__.e/* require.ensure */(107).then((function () {
    return r(__webpack_require__("iorC"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiFakeQuery = [{
  path: '/antifake/query',
  name: 'antiFake-query',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antifake/query/list',
  children: [{
    path: 'list',
    name: 'antiFake-query-list',
    component: queryList,
    meta: {
      displayName: '防伪查询列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiFakeQuery);

/***/ }),

/***/ "TR5y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.showLoading),expression:"showLoading"}],attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UP2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var billList = function billList(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__("KQ+Q"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var merchantBill = [{
  path: '/merchant/Bill',
  name: 'merchant-bill',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/merchant/bill/list',
  hidden: true,
  children: [{
    path: 'list',
    component: billList,
    name: 'merchant-bill-list',
    meta: {
      displayName: '商户列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (merchantBill);

/***/ }),

/***/ "UxrG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var challengeList = function challengeList(r) {
  return __webpack_require__.e/* require.ensure */(106).then((function () {
    return r(__webpack_require__("GmsW"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var challengeManageChallenge = [{
  path: '/challengeManage/challenge',
  name: 'challengeManage-challenge',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/challengeManage/challenge/list',
  hidden: true,
  children: [{
    path: 'list',
    component: challengeList,
    name: 'challengeManage-challenge-list',
    meta: {
      displayName: '签到入场查询',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (challengeManageChallenge);

/***/ }),

/***/ "VIFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var recordList = function recordList(r) {
  return __webpack_require__.e/* require.ensure */(54).then((function () {
    return r(__webpack_require__("yrgS"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var issuerRecord = [{
  path: '/issuer/record',
  name: 'issuer-record',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/issuer/record/list',
  children: [{
    path: 'list',
    name: 'issuer-record-list',
    component: recordList,
    meta: {
      displayName: '发行码',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (issuerRecord);

/***/ }),

/***/ "Vhhy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var extendModuleList = function extendModuleList(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__("FgfD"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemExtendModule = [{
  path: '/system/extendModule',
  name: 'system-extendModule',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/extendModule/list',
  hidden: true,
  children: [{
    path: 'list',
    component: extendModuleList,
    name: 'system-extendModule-list',
    meta: {
      displayName: '可扩展模块',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemExtendModule);

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__http__ = __webpack_require__("gfkZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__("gyMJ");






var _mutations;





var state = {
  visitedViews: [],
  isCollapse: false,
  moduleMenus: {},
  menus: [],
  activeIndex: '',
  // backgroundColor: '#2d3a4b'
  backgroundColor: '#373d41',
  systemTitle: ''
};

var actions = {
  addVisitedViews: function addVisitedViews(_ref, view) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* ADD_VISITED_VIEWS */], view);
  },
  delVisitedViews: function delVisitedViews(_ref2, view) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* DEL_VISITED_VIEWS */], view);
      resolve([].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(state.visitedViews)));
    });
  },
  toggleSidebar: function toggleSidebar(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* TOGGLE_SIDEBAR */]);
  },
  getModuleMenus: function getModuleMenus(_ref4) {
    var commit = _ref4.commit;

    return __WEBPACK_IMPORTED_MODULE_6__http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_7__api__["_338" /* moduleMenus */]).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* GET_MODULE_MENUS */], res.data);
    });
  },
  getMenus: function getMenus(_ref5, playload) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* GET_MENUS */], playload);
  },
  setActiveIndex: function setActiveIndex(_ref6, playload) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SET_ACTIVE_INDEX */], playload);
  },
  activeMenu: function activeMenu(_ref7, playload) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* ACTIVE_MENU */], playload);
  },
  getSysTitle: function getSysTitle(_ref8) {
    var commit = _ref8.commit;

    return __WEBPACK_IMPORTED_MODULE_6__http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_7__api__["_262" /* getSystemSetTitle */]).then(function (res) {
      console.log(res);
      var title = '码上营销管理平台';
      if (res.status !== 404) {
        title = res.data;
      }
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* GET_SYSTEM_TITLE */], title);
    }).catch(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* GET_SYSTEM_TITLE */], '码上营销管理平台');
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* ADD_VISITED_VIEWS */], function (state, playload) {
  if (state.visitedViews.some(function (v) {
    return v.path === playload.path;
  })) {
    return;
  }
  state.visitedViews.push({ name: playload.meta.displayName, path: playload.path });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* DEL_VISITED_VIEWS */], function (state, playload) {
  var index = void 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref9 = _step.value;

      var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref9, 2);

      var i = _ref10[0];
      var v = _ref10[1];

      if (v.path === playload.path) {
        index = i;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  state.visitedViews.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* TOGGLE_SIDEBAR */], function (state) {
  state.isCollapse = !state.isCollapse;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* GET_MODULE_MENUS */], function (state, playload) {
  state.moduleMenus = playload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* GET_MENUS */], function (state, playload) {
  state.menus = state.moduleMenus.menus[playload.id];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SET_ACTIVE_INDEX */], function (state, playload) {
  state.activeIndex = playload.id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* ACTIVE_MENU */], function (state, playload) {
  var path = playload.path;
  for (var item in state.moduleMenus.menus) {
    var menusArr = state.moduleMenus.menus[item];
    for (var i = 0; i < menusArr.length; i++) {
      if (menusArr[i].webUrl === path) {
        state.activeIndex = item;
        state.menus = state.moduleMenus.menus[item];
      }
      if (menusArr[i].children) {
        for (var j = 0; j < menusArr[i].children.length; j++) {
          var childrenArr = menusArr[i].children[j];
          if (childrenArr.webUrl === path) {
            state.activeIndex = item;
            state.menus = state.moduleMenus.menus[item];
          }
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* GET_SYSTEM_TITLE */], function (state, playload) {
  state.systemTitle = playload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "XRJ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productReturnList = function productReturnList(r) {
  return __webpack_require__.e/* require.ensure */(73).then((function () {
    return r(__webpack_require__("r0l9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictProductReturn = [{
  path: '/antichannelconflict/productreturn',
  name: 'antiChannelConflict-productReturn',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/productreturn/list',
  children: [{
    path: 'list',
    component: productReturnList,
    name: 'antiChannelConflict-productReturn-list',
    meta: {
      displayName: '退货单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictProductReturn);

/***/ }),

/***/ "XhFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var mandiInfoList = function mandiInfoList(r) {
  return __webpack_require__.e/* require.ensure */(97).then((function () {
    return r(__webpack_require__("qOSk"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingMandiInfo = [{
  path: '/marketing/mandiInfo',
  name: 'marketing-mandiInfo',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/mandiInfo/list',
  hidden: true,
  children: [{
    path: 'list',
    component: mandiInfoList,
    name: 'marketing-mandiInfo-list',
    meta: {
      displayName: '获取信息管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingMandiInfo);

/***/ }),

/***/ "XjNP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var dealerList = function dealerList(r) {
  return __webpack_require__.e/* require.ensure */(24).then((function () {
    return r(__webpack_require__("UKqG"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var dealerTreeList = function dealerTreeList(r) {
  return __webpack_require__.e/* require.ensure */(61).then((function () {
    return r(__webpack_require__("CpfB"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var pendingList = function pendingList(r) {
  return __webpack_require__.e/* require.ensure */(110).then((function () {
    return r(__webpack_require__("u5a8"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictDealer = [{
  path: '/antichannelconflict/dealer',
  name: 'antiChannelConflict-dealer',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/dealer/list',
  hidden: true,
  children: [{
    path: 'list',
    component: dealerList,
    name: 'antiChannelConflict-dealer-list',
    meta: {
      displayName: '经销商管理',
      requireAuth: true
    }
  }, {
    path: 'pendinglist',
    component: pendingList,
    name: 'antiChannelConflict-dealer-pendingList',
    meta: {
      displayName: '待审核经销商',
      requireAuth: true
    }
  }, {
    path: 'treelist',
    component: dealerTreeList,
    name: 'antiChannelConflict-dealer-treelist',
    meta: {
      displayName: '经销商管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictDealer);

/***/ }),

/***/ "Xvtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar',
  data: function data() {
    return {
      backgroundColor: this.$store.state.app.backgroundColor
    };
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      this.$store.dispatch('app/getMenus', { id: key });
    },
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('account/getAdminInfo');

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleCommand: function handleCommand(command) {
      if (command === 'changePassword') {
        this.$router.replace({ path: '/system/admin/changepassword' });

        return;
      }

      if (command === 'personalData') {
        this.$router.replace({ path: '/system/admin/personaldata' });

        return;
      }

      if (command === 'loginOut') {
        this.$router.replace({ path: '/login' });
        this.$store.dispatch('account/signOut');
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('app/getModuleMenus').then(function () {
      _this2.$store.dispatch('app/activeMenu', { path: _this2.$route.path });
    });
    this.$store.dispatch('app/getSysTitle');
    this.getData();
  },

  computed: {
    navbar: function navbar() {
      return this.$store.state.app.moduleMenus.subSystems;
    },
    activeIndex: function activeIndex() {
      return this.$store.state.app.activeIndex;
    },
    admin: function admin() {
      return this.$store.state.account.adminInfo;
    },
    title: function title() {
      return this.$store.state.app.systemTitle;
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home__ = __webpack_require__("roEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__("LJum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account__ = __webpack_require__("Rlrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__system_admin__ = __webpack_require__("sts+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__system_module__ = __webpack_require__("xtzT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__system_role__ = __webpack_require__("O9a0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__merchant_bill__ = __webpack_require__("UP2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__merchant_manage__ = __webpack_require__("eELU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__merchant_recharge__ = __webpack_require__("uxDU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__system_childrenSystem__ = __webpack_require__("ulcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__antiChannelConflict_checkUserAccount__ = __webpack_require__("/l5A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__antiChannelConflict_dealer__ = __webpack_require__("XjNP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__antiChannelConflict_dealerLevel__ = __webpack_require__("ngS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__antiChannelConflict_inStock__ = __webpack_require__("+1nI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__antiChannelConflict_outStock__ = __webpack_require__("DJNP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__antiChannelConflict_pdaAccount__ = __webpack_require__("ahXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__antiChannelConflict_packingRule__ = __webpack_require__("I3yB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__antiChannelConflict_productReturn__ = __webpack_require__("XRJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__antiChannelConflict_warehouse__ = __webpack_require__("o0VT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__antiChannelConflict_stock__ = __webpack_require__("9op+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__antiFake_code__ = __webpack_require__("8bCQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__antiFake_query__ = __webpack_require__("Sa2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__antiFake_response__ = __webpack_require__("K3ui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__issuerCodes_code__ = __webpack_require__("7CXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__issuerCodes_record__ = __webpack_require__("VIFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__products_brand__ = __webpack_require__("bYo7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__products_order__ = __webpack_require__("q1OT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__products_product__ = __webpack_require__("jVqs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__system_payment__ = __webpack_require__("Zrht");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__system_sms__ = __webpack_require__("CuH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__system_aliyunsms__ = __webpack_require__("hq39");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__mall_deliveryTemplate__ = __webpack_require__("Bj3L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__products_productCategory__ = __webpack_require__("gv6W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__products_productPropertyCategory__ = __webpack_require__("Joow");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__products_productProperty__ = __webpack_require__("htVC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__system_siteProps__ = __webpack_require__("k6gR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__system_officialAccount__ = __webpack_require__("Hc6X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__system_scheduling__ = __webpack_require__("+4Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__userManage_user__ = __webpack_require__("nP0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__areas_area__ = __webpack_require__("yBmF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__basic_advert__ = __webpack_require__("Iegp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__basic_express__ = __webpack_require__("f8dm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__mall_servicePromise__ = __webpack_require__("ypti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__mall_order__ = __webpack_require__("d3R0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__system_templateMessage__ = __webpack_require__("7PgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__antiChannelConflict_antiChannelConflictCode__ = __webpack_require__("ASjJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__antiChannelConflict_antiChannelConflictQuery__ = __webpack_require__("fPR0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__mall_mallProduct__ = __webpack_require__("mi3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__mall_mallBrand__ = __webpack_require__("y369");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__mall_mallProductCategory__ = __webpack_require__("EyZB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__mall_mallProductProperty__ = __webpack_require__("BtP3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__mall_mallProductPropertyCategory__ = __webpack_require__("As03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__replenishment_replenishOrder__ = __webpack_require__("uPCz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__replenishment_replenishProduct__ = __webpack_require__("xZ7z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__replenishment_deliveryTemplate__ = __webpack_require__("S10J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__replenishment_replenishProductBrand__ = __webpack_require__("/lsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__replenishment_replenishProductCategory__ = __webpack_require__("quXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__replenishment_replenishProductProperty__ = __webpack_require__("dgDV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__replenishment_replenishProductPropertyCategory__ = __webpack_require__("vhjj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__replenishment_replenishProductPropertyValue__ = __webpack_require__("+jFo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__officialAccounts_menu__ = __webpack_require__("IKF5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__marketing_activity__ = __webpack_require__("9EKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__marketing_activityUserGrant__ = __webpack_require__("+UP+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__marketing_award__ = __webpack_require__("D8b9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__marketing_lotteryRecord__ = __webpack_require__("vko2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__marketing_RedPacketDate__ = __webpack_require__("lx4F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__marketing_freeAwardInformation__ = __webpack_require__("G0TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__marketing_HelpAwardTotal__ = __webpack_require__("qmp6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__marketing_Chart__ = __webpack_require__("8/Mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__marketing_kadierInfo__ = __webpack_require__("isQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__marketing_mandiInfo__ = __webpack_require__("XhFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__exhibitionHall_activity__ = __webpack_require__("IyUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__exhibitionHall_activityUser__ = __webpack_require__("R0cm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__exhibitionHall_award__ = __webpack_require__("33r8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__exhibitionHall_winner__ = __webpack_require__("E6zw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__updater_resource__ = __webpack_require__("IXym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__antiChannelConflict_dealerUpdate__ = __webpack_require__("2cr8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__sales_posSeller__ = __webpack_require__("QEYw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__sales_areaManager__ = __webpack_require__("AlMv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__sales_pos__ = __webpack_require__("1uch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__mall_integral__ = __webpack_require__("byBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__wechatExcellent_productDealer__ = __webpack_require__("ROV/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__wechatExcellent_dealerBlack__ = __webpack_require__("/7tb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__wechatExcellent_joinInApply__ = __webpack_require__("B/Vv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__wechatExcellent_news__ = __webpack_require__("3RIY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__wechatExcellent_dealerStock__ = __webpack_require__("c3CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__wechatExcellent_order__ = __webpack_require__("8vIo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__wechatExcellent_invoice__ = __webpack_require__("k+dX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__wechatExcellent_consumerFeedback__ = __webpack_require__("A2m0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__wechatExcellent_message__ = __webpack_require__("ziOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__wechatExcellent_productExtend__ = __webpack_require__("9x8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__wechatExcellent_report__ = __webpack_require__("O6zn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__system_extendModule_js__ = __webpack_require__("Vhhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__challengeManage_challenge_js__ = __webpack_require__("UxrG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__jinluxin_product__ = __webpack_require__("a5hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__system_miniProgramConfig__ = __webpack_require__("buQR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__marketing_camera__ = __webpack_require__("tBis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__marketing_agent__ = __webpack_require__("qnbZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__marketing_supermarket__ = __webpack_require__("pHlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__marketing_marketingAction__ = __webpack_require__("+SxG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__marketing_marketingImages__ = __webpack_require__("2Bnn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__ywt_product__ = __webpack_require__("KQaJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__ywt_integral__ = __webpack_require__("5reV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__ywt_productCategory__ = __webpack_require__("b+q9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__ywt_member__ = __webpack_require__("S9/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__ywt_installRegister__ = __webpack_require__("ZdMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__ywt_serviceOrder__ = __webpack_require__("JNZC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__ywt_customer__ = __webpack_require__("eCsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__system_newSms__ = __webpack_require__("/Vqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__autoTable_table__ = __webpack_require__("ADiv");



















































































































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__home__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__error__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__account__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__system_role__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__system_admin__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__system_module__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__merchant_bill__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__merchant_manage__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__merchant_recharge__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__system_childrenSystem__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__antiChannelConflict_dealer__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__antiChannelConflict_dealerLevel__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__antiChannelConflict_inStock__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__antiChannelConflict_outStock__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_19__antiChannelConflict_pdaAccount__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__antiChannelConflict_packingRule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__antiChannelConflict_productReturn__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__antiChannelConflict_warehouse__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__antiChannelConflict_stock__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_24__antiFake_code__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_25__antiFake_query__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_26__antiFake_response__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_27__issuerCodes_code__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_28__issuerCodes_record__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_29__products_brand__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_30__products_order__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_31__products_product__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_32__system_payment__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_33__system_sms__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_34__system_aliyunsms__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_35__mall_deliveryTemplate__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_36__products_productCategory__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_37__products_productPropertyCategory__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_38__products_productProperty__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_39__system_siteProps__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_40__system_officialAccount__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_41__system_scheduling__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_42__userManage_user__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_43__areas_area__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_44__basic_advert__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_45__basic_express__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_46__mall_servicePromise__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_47__mall_order__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_48__system_templateMessage__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_49__antiChannelConflict_antiChannelConflictCode__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_50__antiChannelConflict_antiChannelConflictQuery__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_51__mall_mallProduct__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_52__mall_mallBrand__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_53__mall_mallProductCategory__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_54__mall_mallProductProperty__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_55__mall_mallProductPropertyCategory__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_56__replenishment_replenishOrder__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_57__replenishment_replenishProduct__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_58__replenishment_deliveryTemplate__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_59__replenishment_replenishProductBrand__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_60__replenishment_replenishProductCategory__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_61__replenishment_replenishProductProperty__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_62__replenishment_replenishProductPropertyCategory__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_63__replenishment_replenishProductPropertyValue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_64__officialAccounts_menu__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_65__marketing_activity__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_66__marketing_activityUserGrant__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_67__marketing_award__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_68__marketing_lotteryRecord__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_69__marketing_RedPacketDate__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_70__marketing_freeAwardInformation__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_71__marketing_HelpAwardTotal__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_72__marketing_Chart__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_74__marketing_mandiInfo__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_73__marketing_kadierInfo__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_75__exhibitionHall_activity__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_76__exhibitionHall_activityUser__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_77__exhibitionHall_award__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_78__exhibitionHall_winner__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_79__updater_resource__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__antiChannelConflict_checkUserAccount__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_79__updater_resource__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_80__antiChannelConflict_dealerUpdate__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_81__sales_posSeller__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_82__sales_areaManager__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_83__sales_pos__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_84__mall_integral__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_85__wechatExcellent_productDealer__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_86__wechatExcellent_dealerBlack__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_87__wechatExcellent_joinInApply__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_88__wechatExcellent_news__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_89__wechatExcellent_dealerStock__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_90__wechatExcellent_order__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_91__wechatExcellent_invoice__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_92__wechatExcellent_consumerFeedback__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_93__wechatExcellent_message__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_94__wechatExcellent_productExtend__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_95__wechatExcellent_report__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_96__system_extendModule_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_97__challengeManage_challenge_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_98__jinluxin_product__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_99__system_miniProgramConfig__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_100__marketing_camera__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_101__marketing_agent__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_102__marketing_supermarket__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_103__marketing_marketingAction__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_104__marketing_marketingImages__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_105__ywt_product__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_106__ywt_integral__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_107__ywt_productCategory__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_108__ywt_member__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_109__ywt_installRegister__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_110__ywt_serviceOrder__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_111__ywt_customer__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_112__system_newSms__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_113__autoTable_table__["a" /* default */]))
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (r) {
    return r.meta.requireAuth;
  })) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('account/getAccessToken');
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.account.access_token) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('app/getSysTitle');
  window.document.title = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.app.systemTitle;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZdMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var installRegisterList = function installRegisterList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("Dwqm"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ywtInstallRegister = [{
  path: '/ywt/installRegister',
  name: 'ywt-installRegister',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/ywt/installRegister/list',
  children: [{
    path: 'list',
    name: 'ywt-installRegister-list',
    component: installRegisterList,
    meta: {
      displayName: '质保登记',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (ywtInstallRegister);

/***/ }),

/***/ "Zrht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var paymentList = function paymentList(r) {
  return __webpack_require__.e/* require.ensure */(43).then((function () {
    return r(__webpack_require__("51v5"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemPayment = [{
  path: '/system/payment',
  name: 'system-payment',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/payment/configList',
  hidden: true,
  children: [{
    path: 'configList',
    component: paymentList,
    name: 'system-payment-list',
    meta: {
      displayName: '支付配置',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemPayment);

/***/ }),

/***/ "a5hn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productList = function productList(r) {
  return __webpack_require__.e/* require.ensure */(23).then((function () {
    return r(__webpack_require__("phRT"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var jinluxinProduct = [{
  path: '/jinluxin/product',
  name: 'products-product',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/jinluxin/product/list',
  children: [{
    path: 'list',
    name: 'jinluxin-product-list',
    component: productList,
    meta: {
      displayName: '产品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (jinluxinProduct);

/***/ }),

/***/ "ahXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var pdaAccountList = function pdaAccountList(r) {
  return __webpack_require__.e/* require.ensure */(59).then((function () {
    return r(__webpack_require__("2a2c"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictPDAAccount = [{
  path: '/antichannelconflict/pdaaccount',
  name: 'antiChannelConflict-pdaAccount',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/pdaaccount/list',
  children: [{
    path: 'list',
    component: pdaAccountList,
    name: 'antiChannelConflict-pdaAccount-list',
    meta: {
      displayName: 'PDA账号管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictPDAAccount);

/***/ }),

/***/ "atCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar__ = __webpack_require__("jqh9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navbar__ = __webpack_require__("pbcH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appMain__ = __webpack_require__("wtf7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabsView__ = __webpack_require__("dvDZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout',
  components: { sidebar: __WEBPACK_IMPORTED_MODULE_0__sidebar__["a" /* default */], navbar: __WEBPACK_IMPORTED_MODULE_1__navbar__["a" /* default */], appMain: __WEBPACK_IMPORTED_MODULE_2__appMain__["a" /* default */], tabsView: __WEBPACK_IMPORTED_MODULE_3__tabsView__["a" /* default */] },
  data: function data() {
    return {
      backgroundStyle: {
        background: this.$store.state.app.backgroundColor,
        height: 50
      }
    };
  },

  methods: {},
  computed: {
    isCollapse: function isCollapse() {
      return this.$store.state.app.isCollapse;
    }
  }
});

/***/ }),

/***/ "auCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"nav-top"},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":20}},[_c('div',{staticClass:"nav-left"},[_c('div',{staticClass:"logo"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',[_c('el-menu',{attrs:{"default-active":_vm.activeIndex,"mode":"horizontal","background-color":_vm.backgroundColor,"text-color":"#fff","active-text-color":"#ffd04b"},on:{"select":_vm.handleSelect}},_vm._l((_vm.navbar),function(item){return _c('el-menu-item',{key:item.id,attrs:{"index":item.id}},[_vm._v(_vm._s(item.text))])}),1)],1)])]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"nav-message"},[_c('div',{staticClass:"grid-content bg-purple-dark"})]),_vm._v(" "),_c('div',{staticClass:"nav-user"},[_c('div',{staticClass:"grid-content bg-purple-dark"},[_c('el-dropdown',{on:{"command":_vm.handleCommand}},[_c('span',{staticClass:"el-dropdown-link"},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.admin.displayName))]),_c('img',{staticClass:"user-portrait",attrs:{"src":_vm.admin.avatar || '../../../static/images/tx.jpg'}})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"changePassword"}},[_vm._v("修改密码")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"personalData"}},[_vm._v("个人资料")]),_vm._v(" "),_c('el-dropdown-item',{staticClass:"logout",attrs:{"command":"loginOut"}},[_vm._v("退出登录")])],1)],1)],1)])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "axuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  data: function data() {
    return {
      backgroundColor: this.$store.state.app.backgroundColor
    };
  },

  methods: {
    handleOpen: function handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose: function handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    toggleCollapse: function toggleCollapse() {
      this.$store.dispatch('app/toggleSidebar');
    },
    activeMenu: function activeMenu() {
      var path = this.$route.path;
      var moduleMenus = this.$store.state.app.moduleMenus;
      console.log(moduleMenus);
      for (var item in moduleMenus) {
        console.log(item);
        for (var menu in moduleMenus[item]) {
          if (menu.webUrl === path) {
            this.$store.dispatch('app/setActiveIndex', { id: item });
            this.$store.dispatch('app/getMenus', { id: item });
            console.log(item);
            return;
          }
          for (var children in menu) {
            if (children.webUrl === path) {
              this.$store.dispatch('app/setActiveIndex', { id: item });
              this.$store.dispatch('app/getMenus', { id: item });
              console.log(item);
              return;
            }
          }
        }
      }
    }
  },
  computed: {
    isCollapse: function isCollapse() {
      return this.$store.state.app.isCollapse;
    },
    menus: function menus() {
      return this.$store.state.app.menus;
    },
    activeIndex: function activeIndex() {
      return this.$route.path;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "b+q9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productCategoryList = function productCategoryList(r) {
  return __webpack_require__.e/* require.ensure */(31).then((function () {
    return r(__webpack_require__("+R9U"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ywtProductCategory = [{
  path: '/ywt/productCategory',
  name: 'ywt-productCategory',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/ywt/productCategory/list',
  children: [{
    path: 'list',
    name: 'ywt-productCategory-list',
    component: productCategoryList,
    meta: {
      displayName: '产品分类管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (ywtProductCategory);

/***/ }),

/***/ "bTZ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYo7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var brandList = function brandList(r) {
  return __webpack_require__.e/* require.ensure */(48).then((function () {
    return r(__webpack_require__("VKlw"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productsBrand = [{
  path: '/products/brand',
  name: 'products-brand',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/products/brand/list',
  children: [{
    path: 'list',
    name: 'products-brand-list',
    component: brandList,
    meta: {
      displayName: '品牌管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productsBrand);

/***/ }),

/***/ "bbc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting__ = __webpack_require__("W1GH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('Currency', function (value) {
  return __WEBPACK_IMPORTED_MODULE_1_accounting___default.a.formatMoney(value, '￥', 2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('UnsignedCurrency', function (value) {
  return __WEBPACK_IMPORTED_MODULE_1_accounting___default.a.formatMoney(value, '', 2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('IntNumberSeparator', function (value) {
  return __WEBPACK_IMPORTED_MODULE_1_accounting___default.a.formatMoney(value, '', 0);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('FormattersDate', function (value) {
  return value ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY-MM-DD') : '';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('FormattersDateTime', function (value) {
  return value ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY-MM-DD HH:mm:ss') : '';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('FormattersTime', function (value) {
  return value ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('HH:mm:ss') : '';
});

/***/ }),

/***/ "buQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var miniProgramConfigEdit = function miniProgramConfigEdit(r) {
  return __webpack_require__.e/* require.ensure */(91).then((function () {
    return r(__webpack_require__("Kj6W"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemMiniProgramConfig = [{
  path: '/system/miniProgramConfig',
  name: 'system-miniProgramConfig',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/miniProgramConfig/edit',
  children: [{
    path: 'edit',
    component: miniProgramConfigEdit,
    name: 'system-miniProgramConfig-edit',
    meta: {
      displayName: '拍照相机配置',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemMiniProgramConfig);

/***/ }),

/***/ "byBY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var integralList = function integralList(r) {
  return __webpack_require__.e/* require.ensure */(52).then((function () {
    return r(__webpack_require__("IhDn"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var integral = [{
  path: '/mall/integral',
  name: 'mall-integral',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/integral/list',
  hidden: true,
  children: [{
    path: 'list',
    component: integralList,
    name: 'mall-integral-list',
    meta: {
      displayName: '积分管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (integral);

/***/ }),

/***/ "c3CL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var dealerStockList = function dealerStockList(r) {
  return __webpack_require__.e/* require.ensure */(64).then((function () {
    return r(__webpack_require__("5clU"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var wechatExcellentDealerStock = [{
  path: '/wechatExcellent/dealerStock',
  name: 'wechatExcellent-dealerStock',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/dealerStock/list',
  hidden: true,
  children: [{
    path: 'list',
    component: dealerStockList,
    name: 'wechatExcellent-dealedealerStockrLevel-list',
    meta: {
      displayName: '经销商库存管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (wechatExcellentDealerStock);

/***/ }),

/***/ "d3R0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var orderList = function orderList(r) {
  return __webpack_require__.e/* require.ensure */(29).then((function () {
    return r(__webpack_require__("s45Y"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallOrder = [{
  path: '/mall/order',
  name: 'mall-order',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/order/list',
  hidden: true,
  children: [{
    path: 'list',
    component: orderList,
    name: 'mall-order-list',
    meta: {
      displayName: '订单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallOrder);

/***/ }),

/***/ "dgDV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var replenishProductPropertyList = function replenishProductPropertyList(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__("Dbfv"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishProductProperty = [{
  path: '/replenishment/replenishproductproperty',
  name: 'replenishment-replenishProductProperty',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/replenishProductProperty/list',
  hidden: true,
  children: [{
    path: 'list',
    component: replenishProductPropertyList,
    name: 'replenishment-replenishProductProperty-list',
    meta: {
      displayName: '补货产品属性管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishProductProperty);

/***/ }),

/***/ "dvDZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabsView_vue__ = __webpack_require__("6uCM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1116fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabsView_vue__ = __webpack_require__("hEkP");
function injectStyle (ssrContext) {
  __webpack_require__("BWOF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d1116fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1116fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eCsb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var customerList = function customerList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("ZGgm"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ywtCustomer = [{
  path: '/ywt/customer',
  name: 'ywt-customer',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/ywt/customer/list',
  children: [{
    path: 'list',
    name: 'ywt-customer-list',
    component: customerList,
    meta: {
      displayName: '消费者管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (ywtCustomer);

/***/ }),

/***/ "eELU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var manageList = function manageList(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__("iIcI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var merchantManage = [{
  path: '/merchant/manage',
  name: 'merchant-manage',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/merchant/manage/list',
  hidden: true,
  children: [{
    path: 'list',
    component: manageList,
    name: 'merchant-manage-list',
    meta: {
      displayName: '商户列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (merchantManage);

/***/ }),

/***/ "f8dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var expressList = function expressList(r) {
  return __webpack_require__.e/* require.ensure */(55).then((function () {
    return r(__webpack_require__("r7Ym"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var basicExpress = [{
  path: '/basic/express',
  name: 'basic-express',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/basic/express/list',
  hidden: true,
  children: [{
    path: 'list',
    component: expressList,
    name: 'basic-express-list',
    meta: {
      displayName: '快递管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (basicExpress);

/***/ }),

/***/ "fPR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var antiChannelConflictQueryList = function antiChannelConflictQueryList(r) {
  return __webpack_require__.e/* require.ensure */(111).then((function () {
    return r(__webpack_require__("mVzu"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictAntiChannelConflictQuery = [{
  path: '/antichannelconflict/antichannelconflictquery',
  name: 'antiChannelConflict-antiChannelConflictQuery',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/antichannelconflictquery/list',
  children: [{
    path: 'list',
    component: antiChannelConflictQueryList,
    name: 'antiChannelConflict-antiChannelConflictQuery-list',
    meta: {
      displayName: '防窜码列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictAntiChannelConflictQuery);

/***/ }),

/***/ "gfkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);






var domain = document.domain.split('.');
// axios 配置
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 30000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.host = 'http://' + domain[0].substr(0, domain[0].length - 1) + '.' + domain.splice(1).join('.');
// axios.defaults.host = `http://${domain[0].substr(0, domain[0].length - 1)}.${domain.splice(1).join('.')}`
// axios.defaults.host = 'http://localhost'
// axios.defaults.host = 'http://192.168.0.143'
// axios.defaults.host = 'http://ywt.mooshine.cn/'
// axios.defaults.host = 'http://m.mooshine.cn/'
// axios.defaults.host = 'http://localhost:8001'
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.host + '/Api';

// http request 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toggleLoading');
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('account/getAccessToken');
  if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.account.access_token) {
    config.headers['access-token'] = '' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.account.access_token;
  }
  config.timeout = 20000;
  return config;
}, function (error) {
  // debugger
  console.table(error);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// http response 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toggleLoading');
  return response;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toggleLoading');
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // console.log(router.currentRoute)
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({
          path: '/login',
          query: { redirect: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.path }
        });
        break;
      case 400:
        Object(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Notification"])({
          title: '失败',
          message: error.response.data.message,
          type: 'error'
        });
        break;
      case 500:
        Object(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Notification"])({
          title: '出错',
          message: '服务器出错',
          type: 'error'
        });
        break;
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
  }
  Object(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Notification"])({
    title: '出错',
    message: error,
    type: 'error'
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ "gv6W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productCategoryList = function productCategoryList(r) {
  return __webpack_require__.e/* require.ensure */(32).then((function () {
    return r(__webpack_require__("k1I3"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productsProductCategory = [{
  path: '/products/productcategory',
  name: 'products-productCategory',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/products/productcategory/list',
  hidden: true,
  children: [{
    path: 'list',
    component: productCategoryList,
    name: 'products-productCategory-list',
    meta: {
      displayName: '产品分类',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productsProductCategory);

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_299", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return adminList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return adminInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return editAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return delAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return currentAdminInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_455", function() { return uploadAdminAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return editCurrentAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return loadLicense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_414", function() { return roleList; });
/* unused harmony export allRoleList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return addRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_413", function() { return roleInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return editRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return delRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_338", function() { return moduleMenus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return extendModuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return extendModuleEnabledChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_337", function() { return moduleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return addModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_336", function() { return moduleInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return editModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return delModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return allUnmountModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_340", function() { return mountModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return editModuleSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_339", function() { return moduleTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_444", function() { return subSystemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return addSubSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_443", function() { return subSystemInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return editSubSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return delSubSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_445", function() { return subSystemTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return editSubSystemSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_416", function() { return savePermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_331", function() { return merchantList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return addMerchant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_330", function() { return merchantInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return editMerchant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return delMerchant; });
/* unused harmony export merchantAdminList */
/* unused harmony export addMerchantAdmin */
/* unused harmony export merchantAdminInfo */
/* unused harmony export editMerchantAdmin */
/* unused harmony export delMerchantAdmin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_329", function() { return merchantBillList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_328", function() { return merchantBillInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return dealerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return dealerExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return addDealer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return dealerInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return editDealer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return delDealer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return getDealerByParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return getDealerByRecommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return loadDealerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_448", function() { return transferChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return dealerResetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return dealerLevelList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return dealerLevelAllList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return addDealerLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return dealerLevelInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return editDealerLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return delDealerLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return dealerSellAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return importDealers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return dealerPendingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return auditingDealer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_449", function() { return updateDealerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return batchRemoveDealer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return dealerUpdatePendingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return approvedDealerUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_383", function() { return rejectDealerUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return dealerAccountList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return addDealerAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return editDealerAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return delDealerAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return dealerAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return inStockList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return inStockInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return delInStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_352", function() { return outStockList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_351", function() { return outStockInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_353", function() { return outStockShowOtherInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return addOutStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return addSimpleOutStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return editSimpleOutStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return batchRemoveOutStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return batchBackStatusOutStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_442", function() { return stockList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_358", function() { return pdaAccountList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return addPDAAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return editPDAAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return delPDAAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PackingRuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return addPackingRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return editPackingRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return delPackingRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_379", function() { return productReturnList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_378", function() { return productReturnInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return delProductReturn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_471", function() { return warehouseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return addWarehouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_470", function() { return warehouseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return editWarehouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return delWarehouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return antiChannelConflictCodeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return antiChannelConflictQueryList; });
/* unused harmony export antiChannelConflictTestList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return loadAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return loadFullNameAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_298", function() { return lodaSelectedAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return getProviceAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return getAreasByParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return areaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return editArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return delArea; });
/* unused harmony export deliveryInfoList */
/* unused harmony export addDeliveryInfo */
/* unused harmony export deliveryInfoInfo */
/* unused harmony export editDeliveryInfo */
/* unused harmony export delDeliveryInfo */
/* unused harmony export afterSaleList */
/* unused harmony export afterSaleInfo */
/* unused harmony export handleAfterSale */
/* unused harmony export unHandledAfterSaleList */
/* unused harmony export handledAfterSaleList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return antiFakeCodeList; });
/* unused harmony export antiFakeCodeInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return antiFakeQueryList; });
/* unused harmony export antiFakeQueryInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return antiFakeResponseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return antiFakeResponseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addAntiFakeResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return editAntiFakeResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return delAntiFakeResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return loadUnRelationshipIssuerRecords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return issuerCodeList; });
/* unused harmony export issuerCodeInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return issuerRecordList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return issuerRecordInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return addIssuerRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return editIssuerRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return delIssuerRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return brandList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return brandInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return addBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return editBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return delBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_371", function() { return productList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_370", function() { return productInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return addProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return editProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return delProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return imgUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return editProductStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return importProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return batchRemoveProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_349", function() { return orderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return addTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_348", function() { return orderInfo; });
/* unused harmony export addOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return importOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_322", function() { return marketingMDUserAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_321", function() { return marketingKDEUserAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return helpAwardTotalList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return editHelpAwardTotalInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return helpAwardTotalExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return helpAwardInformationlList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return freeAwardInformationlList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return freeAwardInformationExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return editFreeAwardInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return activityUserGrantList; });
/* unused harmony export delUserGrants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return changeUserGrantStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return batchChangeUserGrantStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_380", function() { return productSkuList; });
/* unused harmony export getProductSkuColumn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return addSku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return editSku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return delSku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_369", function() { return productCategoryTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_368", function() { return productCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return addProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return editProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_367", function() { return productCategoryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return delProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_427", function() { return setProductCategorySort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return getTopCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_373", function() { return productPropertyCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return addProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return editProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_372", function() { return productPropertyCategoryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return delProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return getProductPropertyCategoryPropertyVaules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_385", function() { return relationPropertyValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return getProductPropertyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return getProductPropertyValuesByRootValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return delRelationPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_366", function() { return productCategoryCascader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_375", function() { return productPropertyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return addProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return editProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_374", function() { return productPropertyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return delProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_377", function() { return productPropertyValueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return addProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return editProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_376", function() { return productPropertyValueInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return delProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_428", function() { return setProductPropertyValueSort; });
/* unused harmony export productParamsTemplateList */
/* unused harmony export addProductParamsTemplate */
/* unused harmony export editProductParamsTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_356", function() { return paymentConfigList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_357", function() { return paymentModeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return addPaymentConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return editPaymentConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_355", function() { return paymentConfigInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return delPaymentConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_462", function() { return uploadPaymentCert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_435", function() { return smsConfigList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_439", function() { return smsProviderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return addSmsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return editSmsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_434", function() { return smsConfigInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return delSmsConfig; });
/* unused harmony export setSmsConfigDefault */
/* unused harmony export setSmsConfigStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_441", function() { return smsTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_440", function() { return smsTemplateKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return addSmsTemplate; });
/* unused harmony export editSmsTemplate */
/* unused harmony export delSmsTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_436", function() { return smsLogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_343", function() { return newSmsConfigList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_341", function() { return newDelSmsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return addNewSmsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_342", function() { return newSmsConfigInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return editNewSmsConfig; });
/* unused harmony export aliyunSMSList */
/* unused harmony export delAliyunSmsConfig */
/* unused harmony export smsAliyunProviderList */
/* unused harmony export addAliyunSmsConfig */
/* unused harmony export smsAliyunInfo */
/* unused harmony export editAliyunSmsConfig */
/* unused harmony export logList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return batchRemoveLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_332", function() { return mingHuiSMSList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return delMingHuiSmsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_438", function() { return smsMingHuiProviderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return addMingHuiSmsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_437", function() { return smsMingHuiInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return editMingHuiSmsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_334", function() { return mingHuilogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_333", function() { return mingHuibatchRemoveLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return deliveryTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return addDeliveryTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return editDeliveryTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return deliveryTemplateInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return delDeliveryTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_424", function() { return setDeliveryTemplateDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_433", function() { return sitePropList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return editSiteProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return getSystemSetTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_345", function() { return officialAccountInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return editOfficialAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_460", function() { return uploadOfficialAccountPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_461", function() { return uploadOfficialAccountTenPayCert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_469", function() { return userList; });
/* unused harmony export userInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return changeUserStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return batchChangeOpenId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_447", function() { return templateMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_446", function() { return templateMessageInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return editTemplateMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_347", function() { return officialAccountMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return addOfficialAccountMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return editOfficialAccountMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_346", function() { return officialAccountMenuInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return delOfficialAccountMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_381", function() { return publishOfficialAccountMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_344", function() { return newsMediaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_350", function() { return othersMediaLis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return getForeverNews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_418", function() { return scheduledTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_417", function() { return scheduledTaskInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return editScheduledTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return advertList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_415", function() { return saveAdvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return advertInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return advertItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addAdvertItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return editAdvertItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return advertItemInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return delAdvertInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_456", function() { return uploadAdvertItemPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return expressList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return addExpress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return expressInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return editExpress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return delExpress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_458", function() { return uploadExpressPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return allExpress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_423", function() { return servicePromiseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return addServicePromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_422", function() { return servicePromiseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return editServicePromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return delServicePromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_467", function() { return uploadServicePromisePhoto; });
/* unused harmony export mallMasterOrderList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_432", function() { return shippingMallOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_305", function() { return mallOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_306", function() { return mallOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return closeMallOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_304", function() { return mallExpressList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FinishedMallOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_307", function() { return mallOrderPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_313", function() { return mallProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return addMallProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return editMallProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_312", function() { return mallProductInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return delMallProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return editMallProductStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_459", function() { return uploadMallProductPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return importMallProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_320", function() { return mallProductSkuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return addMallProductSku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return editMallProductSku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return delMallProductSku; });
/* unused harmony export getMallProductSkuColumn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_303", function() { return mallBrandList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_302", function() { return mallBrandInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return addMallBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return editMallBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return delMallBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_311", function() { return mallProductCategoryTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_308", function() { return mallProductCategoryCascader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_310", function() { return mallProductCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return addMallProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return editMallProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_309", function() { return mallProductCategoryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return delMallProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_425", function() { return setMallProductCategorySort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return getTopMallCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_317", function() { return mallProductPropertyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return addMallProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return editMallProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_316", function() { return mallProductPropertyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return delMallProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_315", function() { return mallProductPropertyCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return addMallProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return editMallProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_314", function() { return mallProductPropertyCategoryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return delMallProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return getMallPropertyVaules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return getMallProductPropertyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return getMallProductPropertyValuesByRootValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_384", function() { return relationMallPropertyValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return delRelationMallPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_319", function() { return mallProductPropertyValueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return addMallProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return editMallProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_318", function() { return mallProductPropertyValueInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return delMallProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_426", function() { return setMallProductPropertyValueSort; });
/* unused harmony export mallProductParamsTemplateList */
/* unused harmony export addMallProductParamsTemplate */
/* unused harmony export editMallProductParamsTemplate */
/* unused harmony export mallProductParamsTemplateInfo */
/* unused harmony export delMallProductParamsTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return integralList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return integralInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return addIntegral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return editIntegral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return delIntegral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return editIntegralStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_391", function() { return replenishOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_390", function() { return replenishOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_393", function() { return replenishOrderShip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_387", function() { return replenishExpressDrowList; });
/* unused harmony export replenishOrderStatusList */
/* unused harmony export replenishUpdateOrderStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_388", function() { return replenishOrderClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_392", function() { return replenishOrderPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_389", function() { return replenishOrderFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_401", function() { return replenishProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return addReplenishProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return editReplenishProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_400", function() { return replenishProductInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return delReplenishProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return editReplenishProductStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_463", function() { return uploadPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return importReplenishProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_408", function() { return replenishProductSkuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return addReplenishProductSku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return editReplenishProductSku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return delReplenishProductSku; });
/* unused harmony export getReplenishProductSkuColumn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_395", function() { return replenishProductBrandList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_394", function() { return replenishProductBrandInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return addreplenishProductBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return editreplenishProductBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return delreplenishProductBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_399", function() { return replenishProductCategoryTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_398", function() { return replenishProductCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return addReplenishProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return editReplenishProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_397", function() { return replenishProductCategoryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return delReplenishProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_429", function() { return setReplenishProductCategorySort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return getReplenishTopCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_396", function() { return replenishProductCategoryCascader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_403", function() { return replenishProductPropertyCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return addReplenishProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return editReplenishProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_402", function() { return replenishProductPropertyCategoryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return delReplenishProductPropertyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return getReplenishProductPropertyCategoryPropertyVaules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_386", function() { return relationReplenishPropertyValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return getReplenishProductPropertyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return getReplenishProductPropertyValuesByRootValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return delReplenishRelationPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_405", function() { return replenishProductPropertyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return addReplenishProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return editReplenishProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_404", function() { return replenishProductPropertyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return delReplenishProductProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_407", function() { return replenishProductPropertyValueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return addReplenishProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return editReplenishProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_406", function() { return replenishProductPropertyValueInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return delReplenishProductPropertyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_430", function() { return setReplenishProductPropertyValueSort; });
/* unused harmony export replenishProductParamsTemplateList */
/* unused harmony export addReplenishProductParamsTemplate */
/* unused harmony export editReplenishProductParamsTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return chartInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return chartUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return chartActivityRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return chartLuckDraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return chartUserLoyalty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_354", function() { return payBalanceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return activityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return addActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return editActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return activityInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return delActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LotteryRecordExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return activityTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_301", function() { return lotteryRecordList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return editLotteryRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_300", function() { return lotteryRecordInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return loadIssureRecords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_382", function() { return redPacketDateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_454", function() { return uploadActivityBackgroundPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return awardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return addAward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return editAward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return awardInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return delAward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return awardTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_457", function() { return uploadAwardPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return exActivityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return exActivityUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return exAwardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return exWinnerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_410", function() { return resourceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return addResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return editResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_409", function() { return resourceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return delResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_412", function() { return resourceUpdateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return addResourceUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return editResourceUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_411", function() { return resourceUpdateInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return delResourceUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_466", function() { return uploadResourceUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return checkUserAccountList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return addCheckUserAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return editCheckUserAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return delCheckUserAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_364", function() { return possellerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_365", function() { return possellerPendingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return auditingPOSSeller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_453", function() { return updateStatusPOSSeller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_363", function() { return possellerInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return editPOSSeller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_362", function() { return posNameList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_361", function() { return posList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return delPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return addPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return editPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_360", function() { return posInfo; });
/* unused harmony export areaManagerNameList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return areaManagerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return addAreaManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return areaManagerInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return editAreaManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return delAreaManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return areaManagerInfoList; });
/* unused harmony export productDealerSkuList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_485", function() { return weChatExcellentJoinInApplyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_484", function() { return weChatExcellentJoinInApplyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_483", function() { return weChatExcellentJoinInApplyEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_476", function() { return weChatExcellentDealerBlackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_472", function() { return weChatExcellentAddDealerBlack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_480", function() { return weChatExcellentGetDealerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_478", function() { return weChatExcellentDeleteDealerBlack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_497", function() { return weChatExcellentProductDealerPriceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_494", function() { return weChatExcellentProductDealerDefaultPriceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_498", function() { return weChatExcellentProductDealerSkuPriceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_496", function() { return weChatExcellentProductDealerPriceEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_495", function() { return weChatExcellentProductDealerPriceDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_487", function() { return weChatExcellentMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_486", function() { return weChatExcellentMessageInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_473", function() { return weChatExcellentAddMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_479", function() { return weChatExcellentDeleteMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_501", function() { return weChatExcellentProductExtendList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_499", function() { return weChatExcellentProductExtendEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_500", function() { return weChatExcellentProductExtendInfo; });
/* unused harmony export weChatExcellentProductExtendDelete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_502", function() { return weChatExcellentUploadProductExtendVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_515", function() { return wechatExcellentPersonalReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_520", function() { return wechatExcellentTeamReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_505", function() { return wechatExcellentMapReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_506", function() { return wechatExcellentNewDealerReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_507", function() { return wechatExcellentNewDealerReportExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_516", function() { return wechatExcellentRecommendReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_517", function() { return wechatExcellentRecommendReportExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_504", function() { return wechatExcellentDealerTempBounReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_503", function() { return wechatExcellentDealerTempBounExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_518", function() { return wechatExcellentTeamBounsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_519", function() { return wechatExcellentTeamBounsListExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_521", function() { return wechatExcellentTeramBounsOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_492", function() { return weChatExcellentNewsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_489", function() { return weChatExcellentNewsDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_490", function() { return weChatExcellentNewsEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_488", function() { return weChatExcellentNewsAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_491", function() { return weChatExcellentNewsInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_464", function() { return uploadPictures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_451", function() { return updateNewsStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return dealerStockList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return dealerStockIncrease; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return dealerStockEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return dealerStockExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_514", function() { return wechatExcellentOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_513", function() { return wechatExcellentOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_508", function() { return wechatExcellentOrderClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_509", function() { return wechatExcellentOrderConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_512", function() { return wechatExcellentOrderFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_510", function() { return wechatExcellentOrderExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_511", function() { return wechatExcellentOrderExportByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_493", function() { return weChatExcellentOrderShipped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_477", function() { return weChatExcellentDealerOrderCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_482", function() { return weChatExcellentInvoiceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_481", function() { return weChatExcellentInvoiceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_475", function() { return weChatExcellentConsumerFeedbackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_474", function() { return weChatExcellentConsumerFeedbackDelete; });
/* unused harmony export redpacketActivityList */
/* unused harmony export delRedPacketActivity */
/* unused harmony export editRedpacketActivity */
/* unused harmony export redPacketActivityInfo */
/* unused harmony export redpacketLoadIssureRecords */
/* unused harmony export redpacketActivityTypeList */
/* unused harmony export addRedpacketActivity */
/* unused harmony export redPacketAwardList */
/* unused harmony export delRedPacketAward */
/* unused harmony export uploadRedPacketAwardPhoto */
/* unused harmony export redPacketAwardTypeList */
/* unused harmony export addRePacketAward */
/* unused harmony export editRedPacketAward */
/* unused harmony export redPacketAwardInfo */
/* unused harmony export redPacketLotteryRecordList */
/* unused harmony export editRedPacketLotteryRecord */
/* unused harmony export redPacketLotteryRecordInfo */
/* unused harmony export saveCompanyInfo */
/* unused harmony export companyInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return baseCodeList; });
/* unused harmony export signInCodeList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return importIssuerCodeRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return jinLuXinAddProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return jinLuXinEditProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return addAutoTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return getAutoTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return editAutoTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return autoTableList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return delAutoTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return autoTableFiledList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return autoTableJoinFiledList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_465", function() { return uploadQrCodeLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return getMiniProgramConfigForEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return editMiniProgramConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_335", function() { return miniImageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return batchDeleteImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return exportImageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return getAgentPaged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return getAgentForEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return createOrUpdateAgent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return deleteAgent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return importAgent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return getSupermarketPaged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return getSupermarketForEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return createOrUpdateSupermarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return deleteSupermarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return importSupermarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return getMarketingActionPaged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return getMarketingActionForEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return createOrUpdateMarketingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return deleteMarketingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return importMarketingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return getMarketingImagesPaged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return deleteMarketingImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return exportMarketingImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return approveImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return batchAproveImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return exportImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return addYWTProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return editYWTProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_524", function() { return yWTProductInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_468", function() { return useVideoUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return importYwtProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return changeYwtProductName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_523", function() { return yWTProductCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return addYWTProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return editYWTProductCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_522", function() { return yWTProductCategoryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_431", function() { return setYWTProductCategorySort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_526", function() { return ywtIntegralList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_525", function() { return ywtIntegralInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return addYWTIntegral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return editYWTIntegral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return delYWTIntegral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return editYWTIntegralStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_327", function() { return memberList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_324", function() { return memberInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return changeMemberStatu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_323", function() { return memberExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_359", function() { return plumberExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return installRegisterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return installRegisterInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_450", function() { return updateInstallRegisterStatu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return installRegisterCancelAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return installExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_420", function() { return serviceOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_421", function() { return serviceOrderListExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_419", function() { return serviceOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_452", function() { return updateServiceOrderStatu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_326", function() { return memberIntegralList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_325", function() { return memberIntegralExport; });
// account
var login = '/Dashboards/Account/Login';

// admin
var adminList = '/Admin/Dashboards/AdminList';
var adminInfo = '/Admin/Dashboards/AdminInfo';
var editAdmin = '/Admin/Dashboards/EditAdmin';
var AddAdmin = '/Admin/Dashboards/AddAdmin';
var delAdmin = '/Admin/Dashboards/DelAdmin';
var currentAdminInfo = '/Admin/Dashboards/CurrentAdminInfo';
var changePassword = '/Admin/Dashboards/ChangePassword';
var uploadAdminAvatar = '/Admin/Dashboards/UploadAdminAvatar';
var editCurrentAdmin = '/Admin/Dashboards/EditCurrentAdmin';

// loadLicense
var loadLicense = '/Admin/Licenses/LoadLicense';

// role
var roleList = '/Admin/Dashboards/RoleList';
var allRoleList = '/Admin/Dashboards/AllRoleList';
var addRole = '/Admin/Dashboards/AddRole';
var roleInfo = '/Admin/Dashboards/RoleInfo';
var editRole = '/Admin/Dashboards/editRole';
var delRole = '/Admin/Dashboards/delRole';
var moduleMenus = '/Admin/Dashboards/ModuleMenus';

// extendModule
var extendModuleList = '/Admin/Dashboards/ExtendModuleList';
var extendModuleEnabledChange = '/Admin/Dashboards/ExtendModuleEnabledChange';

// module
var moduleList = '/Admin/Dashboards/ModuleList';
var addModule = '/Admin/Dashboards/AddModule';
var moduleInfo = '/Admin/Dashboards/ModuleInfo';
var editModule = '/Admin/Dashboards/EditModule';
var delModule = '/Admin/Dashboards/DelModule';
var allUnmountModules = '/Admin/Dashboards/AllUnmountModules';
var mountModule = '/Admin/Dashboards/MountModule';
var editModuleSort = '/Admin/Dashboards/EditModuleSort';
var moduleTree = '/Admin/Dashboards/ModuleTree';

// subSystem
var subSystemList = '/Admin/Dashboards/SubSystemList';
var addSubSystem = '/Admin/Dashboards/AddSubSystem';
var subSystemInfo = '/Admin/Dashboards/SubSystemInfo';
var editSubSystem = '/Admin/Dashboards/EditSubSystem';
var delSubSystem = '/Admin/Dashboards/DelSubSystem';
var subSystemTree = '/Admin/Dashboards/SubSystemTree';
var editSubSystemSort = '/Admin/Dashboards/EditSubSystemSort';

// permissions
var savePermissions = '/Admin/Dashboards/SavePermissions';

// merchant
var merchantList = '/Admin/Merchant/MerchantList';
var addMerchant = '/Admin/Merchant/AddMerchant';
var merchantInfo = '/Admin/Merchant/MerchantInfo';
var editMerchant = '/Admin/Merchant/EditMerchant';
var delMerchant = '/Admin/Merchant/DelMerchant';

// merchantAdmin
var merchantAdminList = '/Admin/Merchant/MerchantAdminList';
var addMerchantAdmin = '/Admin/Merchant/AddMerchantAdmin';
var merchantAdminInfo = '/Admin/Merchant/MerchantAdminInfo';
var editMerchantAdmin = '/Admin/Merchant/EditMerchantAdmin';
var delMerchantAdmin = '/Admin/Merchant/DelMerchantAdmin';

// merchantBill
var merchantBillList = '/Admin/Merchant/MerchantBillList';
var merchantBillInfo = '/Admin/Merchant/merchantBillInfo';

// antiChannelConflict

// dealer
var dealerList = '/Admin/AntiChannelConflict/DealerList';
var dealerExport = '/Admin/AntiChannelConflict/DealerExport';
var addDealer = '/Admin/AntiChannelConflict/AddDealer';
var dealerInfo = '/Admin/AntiChannelConflict/DealerInfo';
var editDealer = '/Admin/AntiChannelConflict/EditDealer';
var delDealer = '/Admin/AntiChannelConflict/DelDealer';
var getDealerByParent = '/Admin/AntiChannelConflict/GetDealerByParent';
var getDealerByRecommand = '/Admin/AntiChannelConflict/GetDealerByRecommand';
var loadDealerList = '/Admin/AntiChannelConflict/LoadDealerList';
var transferChildren = '/Admin/AntiChannelConflict/TransferChildren';
var dealerResetPassword = '/Admin/AntiChannelConflict/ResetPassword';

// dealerLevel
var dealerLevelList = '/Admin/AntiChannelConflict/DealerLevelList';
var dealerLevelAllList = '/Admin/AntiChannelConflict/DealerLevelAllList';
var addDealerLevel = '/Admin/AntiChannelConflict/AddDealerLevel';
var dealerLevelInfo = '/Admin/AntiChannelConflict/GetDealerLevelInfo';
var editDealerLevel = '/Admin/AntiChannelConflict/EditDealerLevel';
var delDealerLevel = '/Admin/AntiChannelConflict/DelDealerLevel';

var dealerSellAreaList = '/Admin/AntiChannelConflict/DealerSellAreaList';
var importDealers = '/Admin/AntiChannelConflict/ImportDealers';
var dealerPendingList = '/Admin/AntiChannelConflict/DealerPendingList';
var auditingDealer = '/Admin/AntiChannelConflict/AuditingDealer';
var updateDealerStatus = '/Admin/AntiChannelConflict/UpdateDealerStatus';
var batchRemoveDealer = '/Admin/AntiChannelConflict/BatchRemoveDealer';

// dealerUpdate
var dealerUpdatePendingList = '/Admin/AntiChannelConflict/DealerUpdatePendingList';
var approvedDealerUpdate = '/Admin/AntiChannelConflict/ApprovedDealerUpdate';
var rejectDealerUpdate = '/Admin/AntiChannelConflict/RejectDealerUpdate';

// dealerAccount
var dealerAccountList = '/Admin/AntiChannelConflict/DealerAccountList';
var addDealerAccount = '/Admin/AntiChannelConflict/AddDealerAccount';
var editDealerAccount = '/Admin/AntiChannelConflict/EditDealerAccount';
var delDealerAccount = '/Admin/AntiChannelConflict/DelDealerAccount';
var dealerAccount = '/Admin/AntiChannelConflict/DealerAccount';

// inStock
var inStockList = '/Admin/AntiChannelConflict/InStockList';
var inStockInfo = '/Admin/AntiChannelConflict/InStockInfo';
var delInStock = '/Admin/AntiChannelConflict/DelInStock';

// outStock
var outStockList = '/Admin/AntiChannelConflict/OutStockList';
var outStockInfo = '/Admin/AntiChannelConflict/OutStockInfo';
var outStockShowOtherInfo = '/Admin/AntiChannelConflict/ShowOtherInfo';
var addOutStock = '/Admin/AntiChannelConflict/AddOutStock';
var addSimpleOutStock = '/Admin/AntiChannelConflict/AddSimpleOutStock';
var editSimpleOutStock = '/Admin/AntiChannelConflict/EditSimpleOutStock';
var batchRemoveOutStock = '/Admin/AntiChannelConflict/BatchRemoveOutStock';
var batchBackStatusOutStock = '/Admin/AntiChannelConflict/BatchBackStatusOutStock';

// Stock
var stockList = '/Admin/AntiChannelConflict/StockList';

// PDAAccount
var pdaAccountList = '/Admin/AntiChannelConflict/PDAAccountList';
var addPDAAccount = '/Admin/AntiChannelConflict/AddPDAAccount';
var editPDAAccount = '/Admin/AntiChannelConflict/EditPDAAccount';
var delPDAAccount = '/Admin/AntiChannelConflict/DelPDAAccount';

// PackingRule
var PackingRuleList = '/Admin/AntiChannelConflict/PackingRuleList';
var addPackingRule = '/Admin/AntiChannelConflict/addPackingRule';
var editPackingRule = '/Admin/AntiChannelConflict/EditPackingRule';
var delPackingRule = '/Admin/AntiChannelConflict/DelPackingRule';

// productReturn
var productReturnList = '/Admin/AntiChannelConflict/ProductReturnList';
var productReturnInfo = '/Admin/AntiChannelConflict/ProductReturnInfo';
var delProductReturn = '/Admin/AntiChannelConflict/DelProductReturn';

// warehouse
var warehouseList = '/Admin/AntiChannelConflict/WarehouseList';
var addWarehouse = '/Admin/AntiChannelConflict/AddWarehouse';
var warehouseInfo = '/Admin/AntiChannelConflict/WarehouseInfo';
var editWarehouse = '/Admin/AntiChannelConflict/EditWarehouse';
var delWarehouse = '/Admin/AntiChannelConflict/DelWarehouse';

// antiChannelConflictCode
var antiChannelConflictCodeList = '/Admin/AntiChannelConflict/AntiChannelConflictCodeList';
var antiChannelConflictQueryList = '/Admin/AntiChannelConflict/AntiChannelConflictQueryList';
var antiChannelConflictTestList = '/Admin/AntiChannelConflict/GetList';

// area
var loadAreas = '/Admin/Areas/LoadAreas';
var loadFullNameAreas = '/Admin/Areas/LoadFullNameAreas';
var lodaSelectedAreas = '/Admin/Areas/LodaSelectedAreas';
var getProviceAreas = '/Admin/Areas/GetProviceAreas';
var getAreasByParent = '/Admin/Areas/GetAreasByParent';
var areaInfo = '/Admin/Areas/AreaInfo';
var addArea = '/Admin/Areas/AddArea';
var editArea = '/Admin/Areas/EditArea';
var delArea = '/Admin/Areas/DelArea';

// TCL DeliveryInfo
var deliveryInfoList = '/Admin/TCL/DeliveryInfoList';
var addDeliveryInfo = '/Admin/TCL/AddDeliveryInfo';
var deliveryInfoInfo = '/Admin/TCL/DeliveryInfoInfo';
var editDeliveryInfo = '/Admin/TCL/EditDeliveryInfo';
var delDeliveryInfo = '/Admin/TCL/DelDeliveryInfo';

// TCL AfterSale
var afterSaleList = '/Admin/TCL/AfterSaleList';
var afterSaleInfo = '/Admin/TCL/AfterSaleInfo';
var handleAfterSale = '/Admin/TCL/HandleAfterSale';
var unHandledAfterSaleList = '/Admin/TCL/UnHandledAfterSaleList';
var handledAfterSaleList = '/Admin/TCL/HandledAfterSaleList';

// antiFake
// antiFakeCode
var antiFakeCodeList = '/Admin/AntiFake/AntiFakeCodeList';
var antiFakeCodeInfo = '/Admin/AntiFake/AntiFakeCodeInfo';

// antiFakeQuery
var antiFakeQueryList = '/Admin/AntiFake/AntiFakeQueryList';
var antiFakeQueryInfo = '/Admin/AntiFake/AntiFakeQueryInfo';

// antiFakeResponse
var antiFakeResponseList = '/Admin/AntiFake/AntiFakeResponseList';
var antiFakeResponseInfo = '/Admin/AntiFake/AntiFakeResponseInfo';
var addAntiFakeResponse = '/Admin/AntiFake/AddAntiFakeResponse';
var editAntiFakeResponse = '/Admin/AntiFake/EditAntiFakeResponse';
var delAntiFakeResponse = '/Admin/AntiFake/DelAntiFakeResponse';
var loadUnRelationshipIssuerRecords = '/Admin/AntiFake/LoadUnRelationshipIssuerRecords';

// issuerCodes
var issuerCodeList = '/Admin/IssuerCodes/IssuerCodeList';
var issuerCodeInfo = '/Admin/IssuerCodes/IssuerCodeInfo';

// issuerRecord
var issuerRecordList = '/Admin/IssuerCodes/IssuerRecordList';
var issuerRecordInfo = '/Admin/IssuerCodes/IssuerRecordInfo';
var addIssuerRecord = '/Admin/IssuerCodes/AddIssuerRecord';
var editIssuerRecord = '/Admin/IssuerCodes/EditIssuerRecord';
var delIssuerRecord = '/Admin/IssuerCodes/DelIssuerRecord';

// products
// brand
var brandList = '/Admin/Products/BrandList';
var brandInfo = '/Admin/Products/BrandInfo';
var addBrand = '/Admin/Products/AddBrand';
var editBrand = '/Admin/Products/EditBrand';
var delBrand = '/Admin/Products/DelBrand';

// product
var productList = '/Admin/Products/ProductList';
var productInfo = '/Admin/Products/ProductInfo';
var addProduct = '/Admin/Products/AddProduct';
var editProduct = '/Admin/Products/EditProduct';
var delProduct = '/Admin/Products/DelProduct';
var imgUpload = '/Admin/Products/UploadPhoto';
var editProductStatus = '/Admin/Products/EditProductStatus';
var importProducts = '/Admin/Products/ImportProducts';
var batchRemoveProduct = '/Admin/Products/BatchRemoveProduct';

// product order
var orderList = '/Admin/Orders/OrderList';
var addTotal = '/Admin/Orders/AddTotalOrder';
var orderInfo = '/Admin/Orders/OrderInfo';
var addOrder = '/Admin/Orders/AddOrder';
var importOrder = '/Admin/Orders/ImportOrder';

// activity marketingUserArea
var marketingMDUserAreaList = '/Admin/MarketingManDi/MarketingUserAreaList';
var marketingKDEUserAreaList = '/Admin//MarketingKaDiEr/MarketingUserAreaList';

// activity helpAwardTotal
var helpAwardTotalList = '/Admin/MarketingQinQin/HelpList';
var editHelpAwardTotalInfo = '/Admin/MarketingQinQin/EditHelpInfo';
var helpAwardTotalExport = '/Admin/MarketingQinQin/HelpAwardTotalExport';

// activity helpAwardInformation
var helpAwardInformationlList = '/Admin/MarketingQinQin/HelpAwardList';

// activity freeAwardInformation
var freeAwardInformationlList = '/Admin/MarketingQinQin/FreeAwardInformationList';
var freeAwardInformationExport = '/Admin/MarketingQinQin/FreeAwardInformationExport';
var editFreeAwardInformation = '/Admin/MarketingQinQin/EditFreeAwardInformation';

// activity ActivityUserGran
var activityUserGrantList = '/Admin/MarketingShengJie/ActivityUserGrantList';
var delUserGrants = '/Admin/MarketingShengJie/DelUserGrant';
var changeUserGrantStatus = '/Admin/MarketingShengJie/ChangeUserGrantStatus';
var batchChangeUserGrantStatus = '/Admin/MarketingShengJie/BatchChangeUserGrantStatus';

// productSku
var productSkuList = '/Admin/Products/ProductSkuList';
var getProductSkuColumn = '/Admin/Products/GetProductSkuColumn';
var addSku = '/Admin/Products/AddSku';
var editSku = '/Admin/Products/EditSku';
var delSku = '/Admin/Products/DelSku';

// productCategory
var productCategoryTree = '/Admin/Products/ProductCategoryTree';
var productCategoryList = '/Admin/Products/ProductCategoryList';
var addProductCategory = '/Admin/Products/AddProductCategory';
var editProductCategory = '/Admin/Products/EditProductCategory';
var productCategoryInfo = '/Admin/Products/ProductCategoryInfo';
var delProductCategory = '/Admin/Products/DelProductCategory';
var setProductCategorySort = '/Admin/Products/SetProductCategorySort';
var getTopCategory = '/Admin/Products/GetTopCategory';

// productPropertyCategory
var productPropertyCategoryList = '/Admin/Products/ProductPropertyCategoryList';
var addProductPropertyCategory = '/Admin/Products/AddProductPropertyCategory';
var editProductPropertyCategory = '/Admin/Products/EditProductPropertyCategory';
var productPropertyCategoryInfo = '/Admin/Products/ProductPropertyCategoryInfo';
var delProductPropertyCategory = '/Admin/Products/DelProductPropertyCategory';
var getProductPropertyCategoryPropertyVaules = '/Admin/Products/GetProductPropertyCategoryPropertyVaules';
var relationPropertyValues = '/Admin/Products/RelationPropertyValues';
var getProductPropertyList = '/Admin/Products/GetProductPropertyList';
var getProductPropertyValuesByRootValue = '/Admin/Products/GetProductPropertyValuesByRootValue';
var delRelationPropertyValue = '/Admin/Products/DelRelationPropertyValue';
var productCategoryCascader = '/Admin/Products/ProductCategoryCascader';

// productProperty
var productPropertyList = '/Admin/Products/ProductPropertyList';
var addProductProperty = '/Admin/Products/AddProductProperty';
var editProductProperty = '/Admin/Products/EditProductProperty';
var productPropertyInfo = '/Admin/Products/ProductPropertyInfo';
var delProductProperty = '/Admin/Products/DelProductProperty';

// productPropertyValue
var productPropertyValueList = '/Admin/Products/ProductPropertyValueList';
var addProductPropertyValue = '/Admin/Products/AddProductPropertyValue';
var editProductPropertyValue = '/Admin/Products/EditProductPropertyValue';
var productPropertyValueInfo = '/Admin/Products/ProductPropertyValueInfo';
var delProductPropertyValue = '/Admin/Products/DelProductPropertyValue';
var setProductPropertyValueSort = '/Admin/Products/SetProductPropertyValueSort';

// productParamsTemplate
var productParamsTemplateList = '/Admin/Products/ProductParamsTemplateList';
var addProductParamsTemplate = '/Admin/Products/AddProductParamsTemplate';
var editProductParamsTemplate = '/Admin/Products/EditProductParamsTemplate';

// payment
var paymentConfigList = '/Admin/Payment/PaymentConfigList';
var paymentModeList = '/Admin/Payment/PaymentModeList';
var addPaymentConfig = '/Admin/Payment/AddPaymentConfig';
var editPaymentConfig = '/Admin/Payment/EditPaymentConfig';
var paymentConfigInfo = '/Admin/Payment/PaymentConfigInfo';
var delPaymentConfig = '/Admin/Payment/DelPaymentConfig';
var uploadPaymentCert = '/Admin/Payment/UploadPaymentCert';

// SMS
var smsConfigList = '/Admin/SMS/SmsConfigList';
var smsProviderList = '/Admin/SMS/SmsProviderList';
var addSmsConfig = '/Admin/SMS/AddSmsConfig';
var editSmsConfig = '/Admin/SMS/EditSmsConfig';
var smsConfigInfo = '/Admin/SMS/SmsConfigInfo';
var delSmsConfig = '/Admin/SMS/DelSmsConfig';
var setSmsConfigDefault = '/Admin/SMS/SetSmsConfigDefault';
var setSmsConfigStatus = '/Admin/SMS/SetSmsConfigStatus';
var smsTemplateList = '/Admin/SMS/SmsTemplateList';
var smsTemplateKeys = '/Admin/SMS/SmsTemplateKeys';
var addSmsTemplate = '/Admin/SMS/AddSmsTemplate';
var editSmsTemplate = '/Admin/SMS/EditSmsTemplate';
var delSmsTemplate = '/Admin/SMS/DelSmsTemplate';
var smsLogList = '/Admin/SMS/SmsLogList';
var newSmsConfigList = '/Admin/SMS/NewSmsConfigList';
var newDelSmsConfig = '/Admin/SMS/NewDelSmsConfig';
var addNewSmsConfig = '/Admin/SMS/AddNewSmsConfig';
var newSmsConfigInfo = '/Admin/SMS/NewSmsConfigInfo';
var editNewSmsConfig = '/Admin/SMS/EditNewSmsConfig';

// FengYeRedPacket
var aliyunSMSList = '/Admin/FengYeRedPacket/SmsConfigList';
var delAliyunSmsConfig = '/Admin/FengYeRedPacket/DelSmsConfig';
var smsAliyunProviderList = '/Admin/FengYeRedPacket/SmsProviderList';
var addAliyunSmsConfig = '/Admin/FengYeRedPacket/AddSmsConfig';
var smsAliyunInfo = '/Admin/FengYeRedPacket/SmsConfigInfo';
var editAliyunSmsConfig = '/Admin/FengYeRedPacket/EditSmsConfig';
var logList = '/Admin/FengYeRedPacket/LogList';
var batchRemoveLog = '/Admin/FengYeRedPacket/BatchRemoveLog';

// MingHui RedPacket
var mingHuiSMSList = '/Admin/FengYeRedPacket/SmsConfigList';
var delMingHuiSmsConfig = '/Admin/FengYeRedPacket/DelSmsConfig';
var smsMingHuiProviderList = '/Admin/FengYeRedPacket/SmsProviderList';
var addMingHuiSmsConfig = '/Admin/FengYeRedPacket/AddSmsConfig';
var smsMingHuiInfo = '/Admin/FengYeRedPacket/SmsConfigInfo';
var editMingHuiSmsConfig = '/Admin/FengYeRedPacket/EditSmsConfig';
var mingHuilogList = '/Admin/FengYeRedPacket/LogList';
var mingHuibatchRemoveLog = '/Admin/FengYeRedPacket/BatchRemoveLog';

// deliveryTemplate
var deliveryTemplateList = '/Admin/DeliveryTemplates/deliveryTemplateList';
var addDeliveryTemplate = '/Admin/DeliveryTemplates/AddDeliveryTemplate';
var editDeliveryTemplate = '/Admin/DeliveryTemplates/EditDeliveryTemplate';
var deliveryTemplateInfo = '/Admin/DeliveryTemplates/DeliveryTemplateInfo';
var delDeliveryTemplate = '/Admin/DeliveryTemplates/DelDeliveryTemplate';
var setDeliveryTemplateDefault = '/Admin/DeliveryTemplates/SetDeliveryTemplateDefault';

// siteProps
var sitePropList = '/Admin/SiteProps/SitePropList';
var editSiteProp = '/Admin/SiteProps/EditSiteProp';
var getSystemSetTitle = '/Admin/SiteProps/SystemSetTitle';

// officialAccount
var officialAccountInfo = '/Admin/OfficialAccounts/OfficialAccountInfo';
var editOfficialAccount = '/Admin/OfficialAccounts/EditOfficialAccount';
var uploadOfficialAccountPhoto = '/Admin/OfficialAccounts/UploadOfficialAccountPhoto';
var uploadOfficialAccountTenPayCert = '/Admin/OfficialAccounts/UploadOfficialAccountTenPayCert';

// user
var userList = '/Admin/OfficialAccounts/UserList';
var userInfo = '/Admin/OfficialAccounts/UserInfo';
var changeUserStatus = '/Admin/OfficialAccounts/ChangeUserStatus';
var batchChangeOpenId = '/Admin/OfficialAccounts/BatchChangeOpenId';

// templateMessage
var templateMessageList = '/Admin/OfficialAccounts/TemplateMessageList';
var templateMessageInfo = '/Admin/OfficialAccounts/TemplateMessageInfo';
var editTemplateMessage = '/Admin/OfficialAccounts/EditTemplateMessage';

// officialAccountMenu
var officialAccountMenuList = '/Admin/OfficialAccounts/OfficialAccountMenuList';
var addOfficialAccountMenu = '/Admin/OfficialAccounts/AddOfficialAccountMenu';
var editOfficialAccountMenu = '/Admin/OfficialAccounts/EditOfficialAccountMenu';
var officialAccountMenuInfo = '/Admin/OfficialAccounts/OfficialAccountMenuInfo';
var delOfficialAccountMenu = '/Admin/OfficialAccounts/DelOfficialAccountMenu';
var publishOfficialAccountMenu = '/Admin/OfficialAccounts/PublishOfficialAccountMenu';
var newsMediaList = '/Admin/OfficialAccounts/NewsMediaList';
var othersMediaLis = '/Admin/OfficialAccounts/OthersMediaLis';
var getForeverNews = '/Admin/OfficialAccounts/GetForeverNews';

// scheduledTask
var scheduledTaskList = '/Admin/Scheduling/ScheduledTaskList';
var scheduledTaskInfo = '/Admin/Scheduling/ScheduledTaskInfo';
var editScheduledTask = '/Admin/Scheduling/EditScheduledTask';

// Advertising
var advertList = '/Admin/Advertising/AdvertList';
var saveAdvert = '/Admin/Advertising/SaveAdvert';
var advertInfo = '/Admin/Advertising/AdvertInfo';

// advertItem
var advertItemList = '/Admin/Advertising/AdvertItemList';
var addAdvertItem = '/Admin/Advertising/AddAdvertItem';
var editAdvertItem = '/Admin/Advertising/EditAdvertItem';
var advertItemInfo = '/Admin/Advertising/AdvertItemInfo';
var delAdvertInfo = '/Admin/Advertising/DelAdvertInfo';
var uploadAdvertItemPhoto = '/Admin/Advertising/UploadAdvertItemPhoto';

// express
var expressList = '/Admin/Expresses/ExpressList';
var addExpress = '/Admin/Expresses/AddExpress';
var expressInfo = '/Admin/Expresses/ExpressInfo';
var editExpress = '/Admin/Expresses/EditExpress';
var delExpress = '/Admin/Expresses/DelExpress';
var uploadExpressPhoto = '/Admin/Expresses/UploadExpressPhoto';
var allExpress = '/Admin/Expresses/AllExpress';

// ServicePromise
var servicePromiseList = '/Admin/Mall/ServicePromiseList';
var addServicePromise = '/Admin/Mall/AddServicePromise';
var servicePromiseInfo = '/Admin/Mall/ServicePromiseInfo';
var editServicePromise = '/Admin/Mall/EditServicePromise';
var delServicePromise = '/Admin/Mall/DelServicePromise';
var uploadServicePromisePhoto = '/Admin/Mall/UploadServicePromisePhoto';

// order
var mallMasterOrderList = '/Admin/Mall/MallMasterOrderList';
var shippingMallOrder = '/Admin/Mall/ShippingMallOrder';
var mallOrderInfo = '/Admin/Mall/MallOrderInfo';
var mallOrderList = '/Admin/Mall/MallOrderList';
var closeMallOrder = '/Admin/Mall/CloseMallOrder';
var mallExpressList = '/Admin/Mall/MallExpressList';
var FinishedMallOrder = '/Admin/Mall/FinishedMallOrder';
var mallOrderPay = './Admin/Mall/MallOrderPay';

// mallProduct
var mallProductList = '/Admin/Mall/MallProductList';
var addMallProduct = '/Admin/Mall/AddMallProduct';
var editMallProduct = '/Admin/Mall/EditMallProduct';
var mallProductInfo = '/Admin/Mall/MallProductInfo';
var delMallProduct = '/Admin/Mall/DelMallProduct';
var editMallProductStatus = '/Admin/Mall/EditMallProductStatus';
var uploadMallProductPhoto = '/Admin/Mall/UploadMallProductPhoto';
var importMallProducts = '/Admin/Mall/ImportMallProducts';

// mallProductSku
var mallProductSkuList = '/Admin/Mall/MallProductSkuList';
var addMallProductSku = '/Admin/Mall/AddMallProductSku';
var editMallProductSku = '/Admin/Mall/EditMallProductSku';
var delMallProductSku = '/Admin/Mall/DelMallProductSku';
var getMallProductSkuColumn = '/Admin/Mall/GetMallProductSkuColumn';

// mallBrand
var mallBrandList = '/Admin/Mall/MallBrandList';
var mallBrandInfo = '/Admin/Mall/MallBrandInfo';
var addMallBrand = '/Admin/Mall/AddMallBrand';
var editMallBrand = '/Admin/Mall/EditMallBrand';
var delMallBrand = '/Admin/Mall/DelMallBrand';

// mallProductCategory
var mallProductCategoryTree = '/Admin/Mall/MallProductCategoryTree';
var mallProductCategoryCascader = '/Admin/Mall/MallProductCategoryCascader';
var mallProductCategoryList = '/Admin/Mall/MallProductCategoryList';
var addMallProductCategory = '/Admin/Mall/AddMallProductCategory';
var editMallProductCategory = '/Admin/Mall/EditMallProductCategory';
var mallProductCategoryInfo = '/Admin/Mall/MallProductCategoryInfo';
var delMallProductCategory = '/Admin/Mall/DelMallProductCategory';
var setMallProductCategorySort = '/Admin/Mall/SetMallProductCategorySort';
var getTopMallCategory = '/Admin/Mall/GetTopMallCategory';

// MallProductProperty
var mallProductPropertyList = '/Admin/Mall/MallProductPropertyList';
var addMallProductProperty = '/Admin/Mall/AddMallProductProperty';
var editMallProductProperty = '/Admin/Mall/EditMallProductProperty';
var mallProductPropertyInfo = '/Admin/Mall/MallProductPropertyInfo';
var delMallProductProperty = '/Admin/Mall/DelMallProductProperty';

// mallProductPropertyCategory
var mallProductPropertyCategoryList = '/Admin/Mall/MallProductPropertyCategoryList';
var addMallProductPropertyCategory = '/Admin/Mall/AddMallProductPropertyCategory';
var editMallProductPropertyCategory = '/Admin/Mall/EditMallProductPropertyCategory';
var mallProductPropertyCategoryInfo = '/Admin/Mall/MallProductPropertyCategoryInfo';
var delMallProductPropertyCategory = '/Admin/Mall/DelMallProductPropertyCategory';
var getMallPropertyVaules = '/Admin/Mall/GetMallPropertyVaules';
var getMallProductPropertyList = '/Admin/Mall/GetMallProductPropertyList';
var getMallProductPropertyValuesByRootValue = '/Admin/Mall/GetMallProductPropertyValuesByRootValue';
var relationMallPropertyValues = '/Admin/Mall/RelationMallPropertyValues';
var delRelationMallPropertyValue = '/Admin/Mall/DelRelationMallPropertyValue';

// mallProductPropertyValue
var mallProductPropertyValueList = '/Admin/Mall/MallProductPropertyValueList';
var addMallProductPropertyValue = '/Admin/Mall/AddMallProductPropertyValue';
var editMallProductPropertyValue = '/Admin/Mall/EditMallProductPropertyValue';
var mallProductPropertyValueInfo = '/Admin/Mall/MallProductPropertyValueInfo';
var delMallProductPropertyValue = '/Admin/Mall/DelMallProductPropertyValue';
var setMallProductPropertyValueSort = '/Admin/Mall/SetMallProductPropertyValueSort';

// mallProductParams
var mallProductParamsTemplateList = '/Admin/Mall/MallProductParamsTemplateList';
var addMallProductParamsTemplate = '/Admin/Mall/AddMallProductParamsTemplate';
var editMallProductParamsTemplate = '/Admin/Mall/EditMallProductParamsTemplate';
var mallProductParamsTemplateInfo = '/Admin/Mall/MallProductParamsTemplateInfo';
var delMallProductParamsTemplate = '/Admin/Mall/DelMallProductParamsTemplate';

// mall-integral
var integralList = '/Admin/Mall/IntegralList';
var integralInfo = '/Admin/Mall/IntegralInfo';
var addIntegral = '/Admin/Mall/AddIntegral';
var editIntegral = '/Admin/Mall/EditIntegral';
var delIntegral = '/Admin/Mall/DelIntegral';
var editIntegralStatus = '/Admin/Mall/EditIntegralStatus';

// replenishment
// replenishmentOrder
var replenishOrderList = '/Admin/Replenishment/ReplenishOrderList';
// export const shippingReplenishOrder = '/Admin/Replenishment/ShippingReplenishOrder'
var replenishOrderInfo = '/Admin/Replenishment/ReplenishOrderInfo';
var replenishOrderShip = '/Admin/Replenishment/ReplenishOrderShip';
var replenishExpressDrowList = '/Admin/Replenishment/ExpressDrowList';
var replenishOrderStatusList = '/Admin/Replenishment/OrderStatusList';
var replenishUpdateOrderStatus = '/Admin/Replenishment/UpdateOrderStatus';
var replenishOrderClose = '/Admin/Replenishment/CloseReplenishOrder';
var replenishOrderPay = '/Admin/Replenishment/PayReplenishOrder';
var replenishOrderFinished = '/Admin/Replenishment/FinishedReplenishOrder';

// replenishProduct
var replenishProductList = '/Admin/Replenishment/ReplenishProductList';
var addReplenishProduct = '/Admin/Replenishment/AddReplenishProduct';
var editReplenishProduct = '/Admin/Replenishment/EditReplenishProduct';
var replenishProductInfo = '/Admin/Replenishment/ReplenishProductInfo';
var delReplenishProduct = '/Admin/Replenishment/DelReplenishProduct';
var editReplenishProductStatus = '/Admin/Replenishment/EditReplenishProductStatus';
var uploadPhoto = '/Admin/Replenishment/UploadPhoto';
var importReplenishProducts = '/Admin/Replenishment/ImportReplenishProducts';

// replenishProductSku
var replenishProductSkuList = '/Admin/Replenishment/ReplenishProductSkuList';
var addReplenishProductSku = '/Admin/Replenishment/AddReplenishProductSku';
var editReplenishProductSku = '/Admin/Replenishment/EditReplenishProductSku';
var delReplenishProductSku = '/Admin/Replenishment/DelReplenishProductSku';
var getReplenishProductSkuColumn = '/Admin/Replenishment/GetReplenishProductSkuColumn';

// replenishProductBrand
var replenishProductBrandList = '/Admin/Replenishment/ReplenishProductBrandList';
var replenishProductBrandInfo = '/Admin/Replenishment/ReplenishProductBrandInfo';
var addreplenishProductBrand = '/Admin/Replenishment/AddReplenishProductBrand';
var editreplenishProductBrand = '/Admin/Replenishment/EditReplenishProductBrand';
var delreplenishProductBrand = '/Admin/Replenishment/DelReplenishProductBrand';

// replenishProductCategory
var replenishProductCategoryTree = '/Admin/Replenishment/ProductCategoryTree';
var replenishProductCategoryList = '/Admin/Replenishment/ProductCategoryList';
var addReplenishProductCategory = '/Admin/Replenishment/AddProductCategory';
var editReplenishProductCategory = '/Admin/Replenishment/EditProductCategory';
var replenishProductCategoryInfo = '/Admin/Replenishment/ProductCategoryInfo';
var delReplenishProductCategory = '/Admin/Replenishment/DelProductCategory';
var setReplenishProductCategorySort = '/Admin/Replenishment/SetProductCategorySort';
var getReplenishTopCategory = '/Admin/Replenishment/GetTopCategory';
var replenishProductCategoryCascader = '/Admin/Replenishment/ProductCategoryCascader';

// replenishproductPropertyCategory
var replenishProductPropertyCategoryList = '/Admin/Replenishment/ProductPropertyCategoryList';
var addReplenishProductPropertyCategory = '/Admin/Replenishment/AddProductPropertyCategory';
var editReplenishProductPropertyCategory = '/Admin/Replenishment/EditProductPropertyCategory';
var replenishProductPropertyCategoryInfo = '/Admin/Replenishment/ProductPropertyCategoryInfo';
var delReplenishProductPropertyCategory = '/Admin/Replenishment/DelProductPropertyCategory';
var getReplenishProductPropertyCategoryPropertyVaules = '/Admin/Replenishment/GetProductPropertyCategoryPropertyVaules';
var relationReplenishPropertyValues = '/Admin/Replenishment/RelationPropertyValues';
var getReplenishProductPropertyList = '/Admin/Replenishment/GetProductPropertyList';
var getReplenishProductPropertyValuesByRootValue = '/Admin/Replenishment/GetProductPropertyValuesByRootValue';
var delReplenishRelationPropertyValue = '/Admin/Replenishment/DelRelationPropertyValue';

// replenishproductProperty
var replenishProductPropertyList = '/Admin/Replenishment/ProductPropertyList';
var addReplenishProductProperty = '/Admin/Replenishment/AddProductProperty';
var editReplenishProductProperty = '/Admin/Replenishment/EditProductProperty';
var replenishProductPropertyInfo = '/Admin/Replenishment/ProductPropertyInfo';
var delReplenishProductProperty = '/Admin/Replenishment/DelProductProperty';

// replenishproductPropertyValue
var replenishProductPropertyValueList = '/Admin/Replenishment/ReplenishProductPropertyValueList';
var addReplenishProductPropertyValue = '/Admin/Replenishment/AddReplenishProductPropertyValue';
var editReplenishProductPropertyValue = '/Admin/Replenishment/EditReplenishProductPropertyValue';
var replenishProductPropertyValueInfo = '/Admin/Replenishment/ReplenishProductPropertyValueInfo';
var delReplenishProductPropertyValue = '/Admin/Replenishment/DelReplenishProductPropertyValue';
var setReplenishProductPropertyValueSort = '/Admin/Replenishment/SetReplenishProductPropertyValueSort';

// replenishproductParamsTemplate
var replenishProductParamsTemplateList = '/Admin/Replenishment/ProductParamsTemplateList';
var addReplenishProductParamsTemplate = '/Admin/Replenishment/AddProductParamsTemplate';
var editReplenishProductParamsTemplate = '/Admin/Replenishment/EditProductParamsTemplate';

// chart
var chartInfo = '/Admin/Marketing/ChartInfo';
var chartUserInfo = '/Admin/Marketing/UserInfo';
var chartActivityRate = '/Admin/Marketing/ActivityRate';
var chartLuckDraw = '/Admin/Marketing/LuckDraw';
var chartUserLoyalty = '/Admin/Marketing/UserLoyalty';

// activity
var payBalanceInfo = '/Admin/Marketing/PayBalanceInfo';
var activityList = '/Admin/Marketing/ActivityList';
var addActivity = '/Admin/Marketing/AddActivity';
var editActivity = '/Admin/Marketing/EditActivity';
var activityInfo = '/Admin/Marketing/ActivityInfo';
var delActivity = '/Admin/Marketing/DelActivity';
var LotteryRecordExport = '/Admin/Marketing/LotteryRecordExport';
var activityTypeList = '/Admin/Marketing/ActivityTypeList';
var lotteryRecordList = '/Admin/Marketing/LotteryRecordList';
var editLotteryRecord = '/Admin/Marketing/EditLotteryRecord';
var lotteryRecordInfo = '/Admin/Marketing/LotteryRecordInfo';
var loadIssureRecords = '/Admin/Marketing/LoadUnRelationshipIssuerRecords';
var redPacketDateList = '/Admin/Marketing/RedPacketDateList';
var uploadActivityBackgroundPhoto = '/Admin/Marketing/UploadActivityBackgroundPhoto';

// award
var awardList = '/Admin/Marketing/AwardList';
var addAward = '/Admin/Marketing/AddAward';
var editAward = '/Admin/Marketing/EditAward';
var awardInfo = '/Admin/Marketing/AwardInfo';
var delAward = '/Admin/Marketing/DelAward';
var awardTypeList = '/Admin/Marketing/AwardTypeList';
var uploadAwardPhoto = '/Admin/Marketing/UploadAwardPhoto';

// exhibitionHall
var exActivityList = '/Admin/ExhibitionHall/ActivityList';
var exActivityUserList = '/Admin/ExhibitionHall/ActivityUserList';
var exAwardList = '/Admin/ExhibitionHall/AwardList';
var exWinnerList = '/Admin/ExhibitionHall/WinnerList';

// updater
// resource
var resourceList = '/Admin/Updater/ResourceList';
var addResource = '/Admin/Updater/AddResource';
var editResource = '/Admin/Updater/EditResource';
var resourceInfo = '/Admin/Updater/ResourceInfo';
var delResource = '/Admin/Updater/DelResource';

// resourceUpdate
var resourceUpdateList = '/Admin/Updater/ResourceUpdateList';
var addResourceUpdate = '/Admin/Updater/AddResourceUpdate';
var editResourceUpdate = '/Admin/Updater/EditResourceUpdate';
var resourceUpdateInfo = '/Admin/Updater/ResourceUpdateInfo';
var delResourceUpdate = '/Admin/Updater/DelResourceUpdate';
var uploadResourceUpdate = '/Admin/Updater/UploadResourceUpdate';

// CheckUserAccount
var checkUserAccountList = '/Admin/AntiChannelConflict/CheckUserAccountList';
var addCheckUserAccount = '/Admin/AntiChannelConflict/AddCheckUserAccount';
var editCheckUserAccount = '/Admin/AntiChannelConflict/EditCheckUserAccount';
var delCheckUserAccount = '/Admin/AntiChannelConflict/DelCheckUserAccount';

// Sales
// POSSeller
var possellerList = '/Admin/Sales/POSSellerList';
var possellerPendingList = '/Admin/Sales/POSSellerPendingList';
var auditingPOSSeller = '/Admin/Sales/AuditingPOSSeller';
var updateStatusPOSSeller = '/Admin/Sales/UpdateStatusPOSSeller';
var possellerInfo = '/Admin/Sales/POSSellerInfo';
var editPOSSeller = '/Admin/Sales/EditPOSSeller';

// POS
var posNameList = '/Admin/Sales/POSNameList';
var posList = '/Admin/Sales/POSList';
var delPOS = '/Admin/Sales/DelPOS';
var addPOS = '/Admin/Sales/AddPOS';
var editPOS = '/Admin/Sales/EditPOS';
var posInfo = '/Admin/Sales/POSInfo';

// AreaManager
var areaManagerNameList = '/Admin/Sales/AreaManagerNameList';
var areaManagerList = '/Admin/Sales/AreaManagerList';
var addAreaManager = '/Admin/Sales/AddAreaManager';
var areaManagerInfo = '/Admin/Sales/AreaManagerInfo';
var editAreaManager = '/Admin/Sales/EditAreaManager';
var delAreaManager = '/Admin/Sales/DelAreaManager';
var areaManagerInfoList = '/Admin/Sales/AreaManagerInfoList';

// WeChatExcellent
var productDealerSkuList = '/Admin/WeChatExcellent/DealerProductList';
var weChatExcellentJoinInApplyList = '/Admin/WeChatExcellent/JoinInApplyList';
var weChatExcellentJoinInApplyInfo = '/Admin/WeChatExcellent/GetJoinInApplyInfo';
var weChatExcellentJoinInApplyEdit = '/Admin/WeChatExcellent/EditJoinInApplyInfo';
var weChatExcellentDealerBlackList = '/Admin/WeChatExcellent/DealerBlackList';
var weChatExcellentAddDealerBlack = '/Admin/WeChatExcellent/AddDealerBlack';
var weChatExcellentGetDealerList = '/Admin/WeChatExcellent/GetDealerList';
var weChatExcellentDeleteDealerBlack = '/Admin/WeChatExcellent/DeleteDealerBlack';
var weChatExcellentProductDealerPriceList = '/Admin/WeChatExcellent/ProductDealerPriceList';
var weChatExcellentProductDealerDefaultPriceList = '/Admin/WeChatExcellent/ProductDealerDefaultPriceList';
var weChatExcellentProductDealerSkuPriceList = '/Admin/WeChatExcellent/ProductDealerSkuPriceList';
var weChatExcellentProductDealerPriceEdit = '/Admin/WeChatExcellent/ProductDealerPriceEdit';
var weChatExcellentProductDealerPriceDelete = '/Admin/WeChatExcellent/ProductDealerPriceDelete';
var weChatExcellentMessageList = '/Admin/WeChatExcellent/MessageList';
var weChatExcellentMessageInfo = '/Admin/WeChatExcellent/GetMessageInfo';
var weChatExcellentAddMessage = '/Admin/WeChatExcellent/AddMessage';
var weChatExcellentDeleteMessage = '/Admin/WeChatExcellent/DeleteMessage';

var weChatExcellentProductExtendList = '/Admin/WeChatExcellent/ProductExtendList';
var weChatExcellentProductExtendEdit = '/Admin/WeChatExcellent/ProductExtendEdit';
var weChatExcellentProductExtendInfo = '/Admin/WeChatExcellent/ProductExtendInfo';
var weChatExcellentProductExtendDelete = '/Admin/WeChatExcellent/ProductExtendDelete';
var weChatExcellentUploadProductExtendVideo = '/Admin/WeChatExcellent/UploadProductExtendVideo';

// Report
var wechatExcellentPersonalReport = '/Admin/WeChatExcellent/PersonalReport';
var wechatExcellentTeamReport = '/Admin/WeChatExcellent/TeamReport';
var wechatExcellentMapReport = '/Admin/WeChatExcellent/MapReport';
var wechatExcellentNewDealerReport = '/Admin/WeChatExcellent/NewDealerReport';
var wechatExcellentNewDealerReportExport = '/Admin/WeChatExcellent/NewDealerReportExport';
var wechatExcellentRecommendReport = '/Admin/WeChatExcellent/DealerRecommendReport';
var wechatExcellentRecommendReportExport = '/Admin/WeChatExcellent/DealerRecommendReportExport';
var wechatExcellentDealerTempBounReport = '/Admin/WeChatExcellent/DealerTempBounReport';
var wechatExcellentDealerTempBounExport = '/Admin/WeChatExcellent/DealerTempBounExport';
var wechatExcellentTeamBounsList = '/Admin/WeChatExcellent/TeamBounsList';
var wechatExcellentTeamBounsListExport = '/Admin/WeChatExcellent/TeamBounsListExport';
var wechatExcellentTeramBounsOrderList = '/Admin/WeChatExcellent/TeamBounsOrderList';

// News
var weChatExcellentNewsList = '/Admin/WeChatExcellent/NewsList';
var weChatExcellentNewsDelete = '/Admin/WeChatExcellent/DeleteNews';
var weChatExcellentNewsEdit = '/Admin/WeChatExcellent/EditNews';
var weChatExcellentNewsAdd = '/Admin/WeChatExcellent/AddNews';
var weChatExcellentNewsInfo = '/Admin/WeChatExcellent/NewsInfo';
var uploadPictures = '/Admin/WeChatExcellent/UploadPhoto';
var updateNewsStatus = '/Admin/WeChatExcellent/UpdateStatus';

// dealerStock
var dealerStockList = '/Admin/WeChatExcellent/DealerStockList';
var dealerStockIncrease = '/Admin/WeChatExcellent/IncreaseDealerStock';
var dealerStockEdit = '/Admin/WeChatExcellent/EditDealerStock';
var dealerStockExport = '/Admin/WeChatExcellent/ExportDealerStock';
//  wechatExcellent Order
var wechatExcellentOrderList = '/Admin/WeChatExcellent/WeChatExcellentOrderList';
var wechatExcellentOrderInfo = '/Admin/WeChatExcellent/WeChatExcellentOrderInfo';
var wechatExcellentOrderClose = '/Admin/WeChatExcellent/WeChatExcellentOrderClose';
var wechatExcellentOrderConfirm = '/Admin/WeChatExcellent/WeChatExcellentOrderConfirm';
var wechatExcellentOrderFinished = '/Admin/WeChatExcellent/WeChatExcellentOrderFinished';
var wechatExcellentOrderExport = '/Admin/WeChatExcellent/WeChatExcellentOrderExport';
var wechatExcellentOrderExportByIds = '/Admin/WeChatExcellent/wechatExcellentOrderExportByIds';
var weChatExcellentOrderShipped = '/Admin/WeChatExcellent/WeChatExcellentOrderShipped';
var weChatExcellentDealerOrderCount = '/Admin/WeChatExcellent/DealerOrderCount';

//  wechatExcellent Invoice
var weChatExcellentInvoiceList = '/Admin/WeChatExcellent/WeChatExcellentInvoiceList';
var weChatExcellentInvoiceInfo = '/Admin/WeChatExcellent/WeChatExcellentInvoiceInfo';

// ConsumerFeedback
var weChatExcellentConsumerFeedbackList = '/Admin/WeChatExcellent/ConsumerFeedbackList';
var weChatExcellentConsumerFeedbackDelete = '/Admin/WeChatExcellent/ConsumerFeedbackDelete';

// FengYeRedpacket
var redpacketActivityList = '/Admin/FengYeRedPacket/RedpacketActivityList';
var delRedPacketActivity = '/Admin/FengYeRedPacket/DelRedPacketActivity';
var editRedpacketActivity = '/Admin/FengYeRedPacket/EditRedpacketActivity';
var redPacketActivityInfo = '/Admin/FengYeRedPacket/RedPacketActivityInfo';
var redpacketLoadIssureRecords = '/Admin/FengYeRedPacket/RedpacketLoadIssureRecords';
var redpacketActivityTypeList = '/Admin/FengYeRedPacket/RedpacketActivityTypeList';
var addRedpacketActivity = '/Admin/FengYeRedPacket/AddRedpacketActivity';
var redPacketAwardList = '/Admin/FengYeRedPacket/RedPacketAwardList';
var delRedPacketAward = '/Admin/FengYeRedPacket/DelRedPacketAward';
var uploadRedPacketAwardPhoto = '/Admin/FengYeRedPacket/UploadRedPacketAwardPhoto';
var redPacketAwardTypeList = '/Admin/FengYeRedPacket/RedPacketAwardTypeList';
var addRePacketAward = '/Admin/FengYeRedPacket/AddRePacketAward';
var editRedPacketAward = 'Admin/FengYeRedPacket/EditRedPacketAward';
var redPacketAwardInfo = 'Admin/FengYeRedPacket/RedPacketAwardInfo';
var redPacketLotteryRecordList = 'Admin/FengYeRedPacket/RedPacketLotteryRecordList';
var editRedPacketLotteryRecord = 'Admin/FengYeRedPacket/EditRedPacketLotteryRecord';
var redPacketLotteryRecordInfo = 'Admin/FengYeRedPacket/RedPacketLotteryRecordInfo';

// CompanyInfo
var saveCompanyInfo = '/Admin/AntiChannelConflict/saveCompanyInfo';
var companyInfo = '/Admin/AntiChannelConflict/companyInfo';

// Challenge
var baseCodeList = 'Admin/Challenge/baseCodeList';
var signInCodeList = 'Admin/Challenge/signInCodeList';
var importIssuerCodeRef = '/Admin/IssuerCodes/ImportIssuerCodeRef';
// JinLuXin
var jinLuXinAddProduct = '/Admin/jinLuXin/AddProduct';
var jinLuXinEditProduct = '/Admin/jinLuXin/EditProduct';

// AutoTable
var addAutoTable = '/Admin/AutoTable/Add';
var getAutoTable = '/Admin/AutoTable/GetInfo';
var editAutoTable = '/Admin/AutoTable/Edit';
var autoTableList = '/Admin/AutoTable/List';
var delAutoTable = '/Admin/AutoTable/Del';
var autoTableFiledList = '/Admin/AutoTable/FiledList';
var autoTableJoinFiledList = '/Admin/AutoTable/JoinFiledList';

// miniprogram
var uploadQrCodeLogo = '/MarketingAYB/Admin/UploadLogo';
var getMiniProgramConfigForEdit = '/MarketingAYB/Admin/GetMiniProgramConfigForEdit';
var editMiniProgramConfig = '/MarketingAYB/Admin/EditMiniProgramConfig';
var miniImageList = '/MarketingAYB/Admin/ImageList';
var batchDeleteImage = '/MarketingAYB/Admin/BatchDeleteImage';
var exportImageList = '/MarketingAYB/Admin/ImageRecordExport';

// agent
var getAgentPaged = '/MarketingJinguan/Admin/GetAgentPaged';
var getAgentForEdit = '/MarketingJinguan/Admin/GetAgentForEdit';
var createOrUpdateAgent = '/MarketingJinguan/Admin/CreateOrUpdateAgent';
var deleteAgent = '/MarketingJinguan/Admin/DeleteAgent';
var importAgent = '/MarketingJinguan/Admin/ImportAgent';

// Supermarket
var getSupermarketPaged = '/MarketingJinguan/Admin/GetSupermarketPaged';
var getSupermarketForEdit = '/MarketingJinguan/Admin/GetSupermarketForEdit';
var createOrUpdateSupermarket = '/MarketingJinguan/Admin/CreateOrUpdateSupermarket';
var deleteSupermarket = '/MarketingJinguan/Admin/DeleteSupermarket';
var importSupermarket = '/MarketingJinguan/Admin/ImportSupermarket';

// MarketingAction
var getMarketingActionPaged = '/MarketingJinguan/Admin/GetMarketingActionPaged';
var getMarketingActionForEdit = '/MarketingJinguan/Admin/GetMarketingActionForEdit';
var createOrUpdateMarketingAction = '/MarketingJinguan/Admin/CreateOrUpdateMarketingAction';
var deleteMarketingAction = '/MarketingJinguan/Admin/DeleteMarketingAction';
var importMarketingAction = '/MarketingJinguan/Admin/ImportMarketingAction';

// MarketingImagesJg
var getMarketingImagesPaged = '/MarketingJinguan/Admin/GetMarketingImagesPaged';
var deleteMarketingImages = '/MarketingJinguan/Admin/DeleteMarketingImages';
var exportMarketingImages = '/MarketingJinguan/Admin/ExportMarketingImages';
var approveImage = '/MarketingJinguan/Admin/AproveImage';
var batchAproveImage = '/MarketingJinguan/Admin/batchAproveImage';

var exportImages = '/MarketingJinguan/Admin/ExportImages';

// YaTeWei product
var addYWTProduct = '/MarketingYWT/Admin/AddYWTProduct';
var editYWTProduct = '/MarketingYWT/Admin/EditYWTProduct';
var yWTProductInfo = '/MarketingYWT/Admin/YWTProductInfo';
var useVideoUpload = '/MarketingYWT/Admin/UploadUseVideo';
var importYwtProducts = '/MarketingYWT/Admin/ImportYwtProducts';
var changeYwtProductName = '/MarketingYWT/Admin/ChangeYwtProductName';

// YaTeWei productCategory
var yWTProductCategoryList = '/MarketingYWT/Admin/YWTProductCategoryList';
var addYWTProductCategory = '/MarketingYWT/Admin/AddYWTProductCategory';
var editYWTProductCategory = '/MarketingYWT/Admin/EditYWTProductCategory';
var yWTProductCategoryInfo = '/MarketingYWT/Admin/YWTProductCategoryInfo';
var setYWTProductCategorySort = '/MarketingYWT/Admin/SetYWTProductCategorySort';

// YaTeWei Integral
var ywtIntegralList = '/MarketingYWT/Admin/IntegralList';
var ywtIntegralInfo = '/MarketingYWT/Admin/IntegralInfo';
var addYWTIntegral = '/MarketingYWT/Admin/AddIntegral';
var editYWTIntegral = '/MarketingYWT/Admin/EditIntegral';
var delYWTIntegral = '/MarketingYWT/Admin/DelIntegral';
var editYWTIntegralStatus = '/MarketingYWT/Admin/EditIntegralStatus';

// YaWeiTe Member
var memberList = '/MarketingYWT/Admin/MemberList';
var memberInfo = '/MarketingYWT/Admin/MemberInfo';
var changeMemberStatu = '/MarketingYWT/Admin/ChangeMemberStatu';
var memberExport = '/MarketingYWT/Admin/MemberExport';
var plumberExport = '/MarketingYWT/Admin/PlumberExport';

// YaWeiTe InstallRegister
var installRegisterList = '/MarketingYWT/Admin/InstallRegisterList';
var installRegisterInfo = '/MarketingYWT/Admin/InstallRegisterInfo';
var updateInstallRegisterStatu = '/MarketingYWT/Admin/UpdateInstallRegisterStatu';
var installRegisterCancelAudit = '/MarketingYWT/Admin/InstallRegisterCancelAudit';
var installExport = '/MarketingYWT/Admin/InstallExport';

// YaWeiTe ServiceOrder
var serviceOrderList = '/MarketingYWT/Admin/ServiceOrderList';
var serviceOrderListExport = '/MarketingYWT/Admin/ServiceOrderListExport';
var serviceOrderInfo = '/MarketingYWT/Admin/ServiceOrderInfo';
var updateServiceOrderStatu = '/MarketingYWT/Admin/UpdateServiceOrderStatu';

// YaWeiTe MemberIntegralList
var memberIntegralList = '/MarketingYWT/Admin/MemberIntegralList';
var memberIntegralExport = '/MarketingYWT/Admin/MemberIntegralExport';

/***/ }),

/***/ "hEkP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":24}},_vm._l((Array.from(_vm.visitedViews)),function(tag){return _c('router-link',{key:tag.path,attrs:{"to":tag.path}},[_c('el-tag',{attrs:{"closable":true,"type":_vm.isActive(tag.path) ? '' : 'info'},on:{"close":function($event){return _vm.closeViewTabs(tag,$event)}}},[_vm._v("\n          "+_vm._s(tag.name)+"\n        ")])],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hq39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var aliyunsmsList = function aliyunsmsList(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__("B5aF"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var smslogList = function smslogList(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__("fMvI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemAliyun = [{
  path: '/system/aliyunsms',
  name: 'system-aliyunsms',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/aliyunsms/list',
  hidden: true,
  children: [{
    path: 'list',
    component: aliyunsmsList,
    name: 'system-aliyunsms-list',
    meta: {
      displayName: '短信配置',
      requireAuth: true
    }
  }, {
    path: 'smsloglist',
    component: smslogList,
    name: 'system-aliyunsms-smslogList',
    meta: {
      displayName: '短信日志',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemAliyun);

/***/ }),

/***/ "htVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productPropertyList = function productPropertyList(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__("ijVb"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productsproductProperty = [{
  path: '/products/productproperty',
  name: 'products-productProperty',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/products/productproperty/list',
  hidden: true,
  children: [{
    path: 'list',
    component: productPropertyList,
    name: 'products-productProperty-list',
    meta: {
      displayName: '产品属性类型',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productsproductProperty);

/***/ }),

/***/ "ifeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('el-container',{staticStyle:{"height":"100%","overflow-y":"scroll"}},[_c('el-header',{staticStyle:{"background":"#373d41","height":"50px"},attrs:{"height":"50px"}},[_c('navbar')],1),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":_vm.isCollapse ? '64px' : '180px'}},[_c('div',{staticClass:"el-nav-left",style:(_vm.isCollapse ? 'width:64px' : 'width:180px')},[_c('sidebar')],1)]),_vm._v(" "),_c('el-main',[_c('tabs-view'),_vm._v(" "),_c('appMain')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "isQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var kadierInfoList = function kadierInfoList(r) {
  return __webpack_require__.e/* require.ensure */(98).then((function () {
    return r(__webpack_require__("4RQL"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingKadierInfo = [{
  path: '/marketing/kadierInfo',
  name: 'marketing-kadierInfo',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/kadierInfo/list',
  hidden: true,
  children: [{
    path: 'list',
    component: kadierInfoList,
    name: 'marketing-kadierInfo-list',
    meta: {
      displayName: '卡迪尔获取信息管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingKadierInfo);

/***/ }),

/***/ "jVqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var productList = function productList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__("bz+K"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productsProduct = [{
  path: '/products/product',
  name: 'products-product',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/products/product/list',
  children: [{
    path: 'list',
    name: 'products-product-list',
    component: productList,
    meta: {
      displayName: '产品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productsProduct);

/***/ }),

/***/ "jqh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("axuK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4b84b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("lZDE");
function injectStyle (ssrContext) {
  __webpack_require__("bTZ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4b84b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k+dX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var wechatExcellentInvoiceList = function wechatExcellentInvoiceList(r) {
  return __webpack_require__.e/* require.ensure */(40).then((function () {
    return r(__webpack_require__("KajI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var wechatExcellentInvoice = [{
  path: '/wechatExcellent/invoice',
  name: 'wechatExcellent-invoice',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/invoice/list',
  hidden: true,
  children: [{
    path: 'list',
    component: wechatExcellentInvoiceList,
    name: 'wechatExcellent-invoice-list',
    meta: {
      displayName: '经销商发货单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (wechatExcellentInvoice);

/***/ }),

/***/ "k6gR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var sitePropsEdit = function sitePropsEdit(r) {
  return __webpack_require__.e/* require.ensure */(88).then((function () {
    return r(__webpack_require__("QJKN"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemSiteProps = [{
  path: '/system/siteprops',
  name: 'system-siteProps',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/siteprops/edit',
  children: [{
    path: 'edit',
    component: sitePropsEdit,
    name: 'system-siteProps-edit',
    meta: {
      displayName: '站点配置',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemSiteProps);

/***/ }),

/***/ "lZDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"collapse":_vm.isCollapse,"background-color":"#42485A","text-color":"#fff","active-text-color":"#ccc","router":true,"default-active":_vm.activeIndex},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},[_c('el-menu-item',{attrs:{"index":"#"},nativeOn:{"click":function($event){return _vm.toggleCollapse($event)}}},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("折叠菜单")])]),_vm._v(" "),_vm._l((_vm.menus),function(item){return [(item.children)?_c('el-submenu',{key:item.id,attrs:{"index":item.id}},[_c('template',{slot:"title"},[_c('i',{class:item.iconClass || 'oel-icon-xitongshiti'}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.text))])]),_vm._v(" "),_c('el-menu-item-group',_vm._l((item.children),function(children){return _c('el-menu-item',{key:children.id,attrs:{"index":children.webUrl,"height":"48px"}},[_c('i',{class:children.iconClass || 'oel-icon-xitongshiti'}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(children.text))])])}),1)],2):_c('el-menu-item',{key:item.id,attrs:{"index":item.webUrl}},[_c('i',{class:item.iconClass || 'oel-icon-xitongshiti'}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.text))])])]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lx4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var redPacketDateList = function redPacketDateList(r) {
  return __webpack_require__.e/* require.ensure */(96).then((function () {
    return r(__webpack_require__("n7Nd"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingRedPacketDate = [{
  path: '/marketing/redPacketDate',
  name: 'marketing-redPacketDate',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/redPacketDate/list',
  hidden: true,
  children: [{
    path: 'list',
    component: redPacketDateList,
    name: 'marketing-redPacketDate-list',
    meta: {
      displayName: '抽奖个人记录管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingRedPacketDate);

/***/ }),

/***/ "mi3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var mallProductList = function mallProductList(r) {
  return __webpack_require__.e/* require.ensure */(22).then((function () {
    return r(__webpack_require__("cDRi"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallProduct = [{
  path: '/mall/mallproduct',
  name: 'mall-mallProduct',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/mallProduct/list',
  hidden: true,
  children: [{
    path: 'list',
    component: mallProductList,
    name: 'mall-product-list',
    meta: {
      displayName: '商品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallProduct);

/***/ }),

/***/ "nP0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var userList = function userList(r) {
  return __webpack_require__.e/* require.ensure */(87).then((function () {
    return r(__webpack_require__("uyeW"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var userManageUser = [{
  path: '/usermanage/user',
  name: 'userManage-user',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/usermanage/user/list',
  hidden: true,
  children: [{
    path: 'list',
    component: userList,
    name: 'userManage-user-list',
    meta: {
      displayName: '用户管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (userManageUser);

/***/ }),

/***/ "ngS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var dealerLevelList = function dealerLevelList(r) {
  return __webpack_require__.e/* require.ensure */(34).then((function () {
    return r(__webpack_require__("mqyx"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictDealerLevel = [{
  path: '/antichannelconflict/dealerLevel',
  name: 'antiChannelConflict-dealerLevel',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/dealerLevel/list',
  hidden: true,
  children: [{
    path: 'list',
    component: dealerLevelList,
    name: 'antiChannelConflict-dealerLevel-list',
    meta: {
      displayName: '经销商等级管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictDealerLevel);

/***/ }),

/***/ "o0VT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var warehouseList = function warehouseList(r) {
  return __webpack_require__.e/* require.ensure */(58).then((function () {
    return r(__webpack_require__("Ecbz"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var antiChannelConflictWarehouse = [{
  path: '/antichannelconflict/warehouse',
  name: 'antiConnelConflict-warehouse',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/antichannelconflict/warehouse/list',
  children: [{
    path: 'list',
    name: 'antiConnelConflict-warehouse-list',
    component: warehouseList,
    meta: {
      displayName: '仓库管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (antiChannelConflictWarehouse);

/***/ }),

/***/ "oxOU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pHlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var supermarketList = function supermarketList(r) {
  return __webpack_require__.e/* require.ensure */(79).then((function () {
    return r(__webpack_require__("aWMa"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var supermarketConfig = [{
  path: '/marketing/supermarket',
  name: 'marketing-supermarket',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/supermarket/list',
  hidden: true,
  children: [{
    path: 'list',
    component: supermarketList,
    name: 'system-supermarket-list',
    meta: {
      displayName: '终端管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (supermarketConfig);

/***/ }),

/***/ "pbcH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__("Xvtg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f1fce0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__("auCz");
function injectStyle (ssrContext) {
  __webpack_require__("oxOU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33f1fce0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f1fce0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q1OT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var orderList = function orderList(r) {
  return __webpack_require__.e/* require.ensure */(63).then((function () {
    return r(__webpack_require__("8EcC"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var productsOrder = [{
  path: '/products/order',
  name: 'products-order',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/products/order/list',
  children: [{
    path: 'list',
    name: 'products-order-list',
    component: orderList,
    meta: {
      displayName: '订单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (productsOrder);

/***/ }),

/***/ "qmp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var helpAwardTotalList = function helpAwardTotalList(r) {
  return __webpack_require__.e/* require.ensure */(70).then((function () {
    return r(__webpack_require__("GrWs"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var helpAwardTotalActivity = [{
  path: '/marketing/helpAwardTotal',
  name: 'marketing-helpAwardTotal',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/helpAwardTotal/list',
  hidden: true,
  children: [{
    path: 'list',
    component: helpAwardTotalList,
    name: 'marketing-helpAwardTotal-list',
    meta: {
      displayName: '助力活动管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (helpAwardTotalActivity);

/***/ }),

/***/ "qnbZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var agentList = function agentList(r) {
  return __webpack_require__.e/* require.ensure */(81).then((function () {
    return r(__webpack_require__("5KIE"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var agentConfig = [{
  path: '/marketing/agent',
  name: 'marketing-agent',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/agent/list',
  hidden: true,
  children: [{
    path: 'list',
    component: agentList,
    name: 'marketing-agent-list',
    meta: {
      displayName: '客户管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (agentConfig);

/***/ }),

/***/ "quXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var replenishProductCategoryList = function replenishProductCategoryList(r) {
  return __webpack_require__.e/* require.ensure */(36).then((function () {
    return r(__webpack_require__("nbXf"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishProductCategory = [{
  path: '/replenishment/replenishproductcategory',
  name: 'replenishment-replenishProductCategory',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/replenishProductCategory/list',
  hidden: true,
  children: [{
    path: 'list',
    component: replenishProductCategoryList,
    name: 'replenishment-replenishProductCategory-list',
    meta: {
      displayName: '补货产品分类管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishProductCategory);

/***/ }),

/***/ "rmPg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "roEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_home_index__ = __webpack_require__("KR8f");



var home = [{
  path: '/',
  name: 'home',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/dashboard',
  hidden: true,
  children: [{
    path: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_1__views_home_index__["a" /* default */],
    name: 'dashboard',
    meta: {
      displayName: '首页',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (home);

/***/ }),

/***/ "sts+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var adminList = function adminList(r) {
  return __webpack_require__.e/* require.ensure */(93).then((function () {
    return r(__webpack_require__("/1xt"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var chanegPassword = function chanegPassword(r) {
  return __webpack_require__.e/* require.ensure */(94).then((function () {
    return r(__webpack_require__("dupA"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalData = function personalData(r) {
  return __webpack_require__.e/* require.ensure */(92).then((function () {
    return r(__webpack_require__("5t1X"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var license = function license(r) {
  return __webpack_require__.e/* require.ensure */(115).then((function () {
    return r(__webpack_require__("/2wY"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var systemAdmin = [{
  path: '/system/admin',
  name: 'system-admin',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/admin/list',
  hidden: true,
  children: [{
    path: 'list',
    component: adminList,
    name: 'system-admin-list',
    meta: {
      displayName: '管理员管理',
      requireAuth: true
    }
  }, {
    path: 'changepassword',
    component: chanegPassword,
    name: 'system-admin-changePassword',
    meta: {
      displayName: '修改密码',
      requireAuth: true
    }
  }, {
    path: 'personaldata',
    component: personalData,
    name: 'system-admin-personalData',
    meta: {
      displayName: '个人资料',
      requireAuth: true
    }
  }, {
    path: 'license',
    component: license,
    name: 'system-admin-license',
    meta: {
      displayName: '许可证管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemAdmin);

/***/ }),

/***/ "tBis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var cameraList = function cameraList(r) {
  return __webpack_require__.e/* require.ensure */(25).then((function () {
    return r(__webpack_require__("73o7"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingCamera = [{
  path: '/marketing/camera',
  name: 'marketing-camera',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/camera/list',
  hidden: true,
  children: [{
    path: 'list',
    component: cameraList,
    name: 'marketing-camera-list',
    meta: {
      displayName: '拍照明细管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingCamera);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var replenishOrderList = function replenishOrderList(r) {
  return __webpack_require__.e/* require.ensure */(28).then((function () {
    return r(__webpack_require__("hrXZ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishOrder = [{
  path: '/replenishment/replenishorder',
  name: 'replenishment-replenishOrder',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/replenishorder/list',
  hidden: true,
  children: [{
    path: 'list',
    component: replenishOrderList,
    name: 'replenishment-replenishOrder-list',
    meta: {
      displayName: '补货订单管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishOrder);

/***/ }),

/***/ "ulcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var childrenSystemList = function childrenSystemList(r) {
  return __webpack_require__.e/* require.ensure */(83).then((function () {
    return r(__webpack_require__("QDSP"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var childrenSystem = [{
  path: '/system/childrenSystem',
  name: 'system-childrenSystem',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/childrenSystem/list',
  children: [{
    path: 'list',
    component: childrenSystemList,
    name: 'system-childrenSystem-list',
    meta: {
      displayName: '子系统管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (childrenSystem);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxDU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var rechargeList = function rechargeList(r) {
  return __webpack_require__.e/* require.ensure */(95).then((function () {
    return r(__webpack_require__("TwBx"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var merchantRecharge = [{
  path: '/merchant/Recharge',
  name: 'merchant-recharge',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/merchant/recharge/list',
  hidden: true,
  children: [{
    path: 'list',
    component: rechargeList,
    name: 'merchant-recharge-list',
    meta: {
      displayName: '商户充值列表',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (merchantRecharge);

/***/ }),

/***/ "vhjj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var replenishProductPropertyCategoryList = function replenishProductPropertyCategoryList(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__("GPom"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishProductPropertyCategory = [{
  path: '/replenishment/replenishproductpropertycategory',
  name: 'replenishment-replenishProductPropertyCategory',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/replenishProductPropertyCategory/list',
  hidden: true,
  children: [{
    path: 'list',
    component: replenishProductPropertyCategoryList,
    name: 'replenishment-replenishProductPropertyCategory-list',
    meta: {
      displayName: '补货产品属性分类管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishProductPropertyCategory);

/***/ }),

/***/ "vko2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var lotteryRecordList = function lotteryRecordList(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__("vdKg"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ayblotteryRecordList = function ayblotteryRecordList(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__("Jw3N"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var marketingLotteryRecord = [{
  path: '/marketing/lotteryRecord',
  name: 'marketing-lotteryRecord',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/marketing/lotteryRecord/list',
  hidden: true,
  children: [{
    path: 'list',
    component: lotteryRecordList,
    name: 'marketing-lotteryRecord-list',
    meta: {
      displayName: '抽奖记录管理',
      requireAuth: true
    }
  }, {
    path: 'ayblist',
    component: ayblotteryRecordList,
    name: 'marketing-lotteryRecord-ayblist',
    meta: {
      displayName: '抽奖记录管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (marketingLotteryRecord);

/***/ }),

/***/ "wtf7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_appMain_vue__ = __webpack_require__("4z9Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127b4e62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_appMain_vue__ = __webpack_require__("MUYG");
function injectStyle (ssrContext) {
  __webpack_require__("43a5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_appMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127b4e62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_appMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  computed: {
    showLoading: function showLoading() {
      return this.$store.state.showLoading;
    }
  }
});

/***/ }),

/***/ "xZ7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

// import { replenishProductList } from '../../api';
var replenishProductList = function replenishProductList(r) {
  return __webpack_require__.e/* require.ensure */(21).then((function () {
    return r(__webpack_require__("VFrT"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var replenishProduct = [{
  path: '/replenishment/replenishProduct',
  name: 'replenishment-replenishProduct',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/replenishment/replenishProduct/list',
  children: [{
    path: 'list',
    name: 'replenishment-replenishProduct-list',
    component: replenishProductList,
    meta: {
      displayName: '补货产品管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (replenishProduct);

/***/ }),

/***/ "xtzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var modules = function modules(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__("caym"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var systemModule = [{
  path: '/system/module',
  name: 'system-module',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/system/module/modules',
  hidden: true,
  children: [{
    path: 'modules',
    component: modules,
    name: 'system-module-modules',
    meta: {
      displayName: '模块管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemModule);

/***/ }),

/***/ "y369":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var brandList = function brandList(r) {
  return __webpack_require__.e/* require.ensure */(51).then((function () {
    return r(__webpack_require__("0nZJ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallProductBrand = [{
  path: '/mall/mallproductbrand',
  name: 'mall-mallProductBrand',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/mallProductBrand/list',
  children: [{
    path: 'list',
    name: 'mall-mallProductBrand-list',
    component: brandList,
    meta: {
      displayName: '品牌管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallProductBrand);

/***/ }),

/***/ "yBmF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var areaList = function areaList(r) {
  return __webpack_require__.e/* require.ensure */(56).then((function () {
    return r(__webpack_require__("6oIQ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var areasArea = [{
  path: '/areas/area',
  name: 'areas-area',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/areas/area/list',
  hidden: true,
  children: [{
    path: 'list',
    component: areaList,
    name: 'areas-area-list',
    meta: {
      displayName: '地区管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (areasArea);

/***/ }),

/***/ "ypti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var servicePromiseList = function servicePromiseList(r) {
  return __webpack_require__.e/* require.ensure */(50).then((function () {
    return r(__webpack_require__("Puq9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var mallServicePromise = [{
  path: '/mall/servicepromise',
  name: 'mall-servicePromise',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/mall/servicepromise/list',
  hidden: true,
  children: [{
    path: 'list',
    component: servicePromiseList,
    name: 'mall-servicePromise-list',
    meta: {
      displayName: '服务承诺',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (mallServicePromise);

/***/ }),

/***/ "ziOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__ = __webpack_require__("4Lha");

var messageList = function messageList(r) {
  return __webpack_require__.e/* require.ensure */(77).then((function () {
    return r(__webpack_require__("BRmh"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var wechatExcellentMessage = [{
  path: '/wechatExcellent/message',
  name: 'wechatExcellent-message',
  component: __WEBPACK_IMPORTED_MODULE_0__views_layout_layout_vue__["a" /* default */],
  redirect: '/wechatExcellent/message/list',
  hidden: true,
  children: [{
    path: 'list',
    component: messageList,
    name: 'wechatExcellent-message-list',
    meta: {
      displayName: '系统消息管理',
      requireAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (wechatExcellentMessage);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c807fbe31d7d9544b81e.js